const ON_CHANGE_DEBOUNCE_TIMER = 300;
const currentDate = new Date();
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
const POST_LINK_INT = 'xml_eval';
let subscribers = {};
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((item) => {
      return item !== callback;
    });
  };
}
function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((item) => {
      item(data);
    });
  }
}
const GIFTS_LOCAL_STORAGE_KEY = 'shrine_gift_goals';
let shouldCheckShrineGifts = false;
let giftsToMonitor = [];
function initShrineGiftsCheck(isCartPage = false) {
  let cartItemsEl = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  if (isCartPage) cartItemsEl = document.querySelector('cart-items');
  if (!cartItemsEl || cartItemsEl.dataset.giftsStorage !== 'true') return;
  const storedGiftsRaw = localStorage.getItem('shrine_gift_goals');
  if (!storedGiftsRaw) return;
  const parsedData = JSON.parse(storedGiftsRaw);
  if (!parsedData || typeof parsedData !== 'object') return;
  Object.values(parsedData).forEach((giftGoal) => {
    const cartItemProductEl = cartItemsEl.querySelector(
      '.cart-item--product-' + giftGoal.gift_handle,
    );
    if (!cartItemProductEl) return;
    const giftProductEl = document.querySelector('.gift--product-' + giftGoal.gift_handle);
    if (giftProductEl) return;
    shouldCheckShrineGifts = true;
    giftsToMonitor.push(giftGoal);
  });
  updateGiftStyles();
  checkShrineGifts(isCartPage);
}
function updateGiftStyles() {
  let shrineGiftsStyleEl = document.getElementById('shrine-gifts-style');
  if (shrineGiftsStyleEl) shrineGiftsStyleEl.remove();
  if (!giftsToMonitor.length) return;
  const styleEl = document.createElement('style');
  styleEl.id = 'shrine-gifts-style';
  const textContent = giftsToMonitor
    .map(
      (item) =>
        '.cart-item--product-' + item.gift_handle + ' .quantity { display: none !important; }',
    )
    .join('\n');
  styleEl.textContent = textContent;
  document.head.appendChild(styleEl);
}
function checkShrineGifts(isCartPage = false) {
  let cartItemsEl = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  if (isCartPage) cartItemsEl = document.querySelector('cart-items');
  if (!shouldCheckShrineGifts || !cartItemsEl || !cartItemsEl.updateQuantity) return;
  for (const giftGoal of giftsToMonitor) {
    const giftCartItemEl = cartItemsEl.querySelector('.cart-item--product-' + giftGoal.gift_handle);
    if (!giftCartItemEl) {
      const giftIndex = giftsToMonitor.findIndex(
        (gift_handle) => gift_handle.gift_handle === giftGoal.gift_handle,
      );
      if (giftIndex > -1) giftsToMonitor.splice(giftIndex, 1);
      removeLocalStorageGift(giftGoal);
      continue;
    }
    let shouldRemoveGift = false;
    if (giftGoal.type === 'product_quantity') {
      let totalQuantity = 0;
      cartItemsEl
        .querySelectorAll('.cart-item--product-' + giftGoal.unlock_product_handle)
        .forEach((cartItemEl) => {
          totalQuantity += parseInt(cartItemEl.dataset.quantity);
        });
      if (totalQuantity < parseInt(giftGoal.required_quantity)) shouldRemoveGift = true;
    } else {
      if (giftGoal.type === 'product_variant') {
        const variantCartItems = cartItemsEl.querySelectorAll(
          '.cart-item--product-' + giftGoal.unlock_product_handle,
        );
        if (!variantCartItems.length) shouldRemoveGift = true;
        else {
          const validVariants = Array.isArray(giftGoal.valid_variants) ? giftGoal.valid_variants : [];
          let hasValidVariant = false;
          let hasVariantOptions = false;
          variantCartItems.forEach((item) => {
            const variantOptionsRaw = item.dataset.variantOptions;
            if (item.dataset.variantOptions) {
              hasVariantOptions = true;
              const variantOptionsList = item.dataset.variantOptions
                .split('|||')
                .map((text) => text.trim().toLowerCase());
              if (variantOptionsList.some((variantOption) => validVariants.includes(variantOption))) {
                hasValidVariant = true;
              }
            }
          });
          if (hasVariantOptions && !hasValidVariant) shouldRemoveGift = true;
        }
      } else {
        const subtotal = parseInt(cartItemsEl.dataset.subtotal);
        if (subtotal < parseInt(giftGoal.required_quantity)) shouldRemoveGift = true;
      }
    }
    if (shouldRemoveGift) {
      const giftIndex = giftsToMonitor.findIndex(
        (gift_handle) => gift_handle.gift_handle === giftGoal.gift_handle,
      );
      if (giftIndex > -1) giftsToMonitor.splice(giftIndex, 1);
      removeLocalStorageGift(giftGoal);
      const lineKey = giftCartItemEl.dataset.index ?? giftCartItemEl.id.replace('CartItem-', '');
      cartItemsEl.updateQuantity(lineKey, 0);
      return;
    }
  }
}
function validateSingleQuantityCartItems(cartItemsEl, handleToIdMap) {
  for (const [handle, targetId] of Object.entries(handleToIdMap)) {
    const matchingItems = cartItemsEl.querySelectorAll('.cart-item--product-' + handle);
    if (matchingItems.length === 0) continue;
    if (matchingItems.length > 1) {
      let keepItem = null;
      let duplicateItems = [];
      matchingItems.forEach((item) => {
        const quantityVariantIdEl = item.querySelector('[data-quantity-variant-id]');
        const itemVariantId = quantityVariantIdEl ? quantityVariantIdEl.dataset.quantityVariantId : null;
        itemVariantId === targetId && !keepItem ? (keepItem = item) : duplicateItems.push(item);
      });
      if (!keepItem && duplicateItems.length > 0) {
        keepItem = duplicateItems.shift();
      }
      if (duplicateItems.length > 0) {
        const removeItem = duplicateItems[0];
        const removeItemKey =
          duplicateItems[0].dataset.index ??
          duplicateItems[0].id.replace('CartItem-', '').replace('CartDrawer-Item-', '');
        cartItemsEl.updateQuantity(removeItemKey, 0);
        return true;
      }
    }
    if (matchingItems.length === 1) {
      const singleItem = matchingItems[0];
      const quantity = parseInt(matchingItems[0].dataset.quantity) || 1;
      if (quantity > 1) {
        const itemKey =
          matchingItems[0].dataset.index ??
          matchingItems[0].id.replace('CartItem-', '').replace('CartDrawer-Item-', '');
        cartItemsEl.updateQuantity(itemKey, 1);
        return true;
      }
    }
  }
  return false;
}
function validateCartGifts(isCartPage = false) {
  const cartDrawerEl = document.querySelector('cart-drawer');
  if (!cartDrawerEl) return;
  let cartItemsEl = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  if (isCartPage) cartItemsEl = document.querySelector('cart-items');
  if (!cartItemsEl || !cartItemsEl.updateQuantity) return;
  const cartDrawerGiftEls = cartDrawerEl.querySelectorAll('cart-drawer-gift');
  const dataToggleTrueEls = cartDrawerEl.querySelectorAll('cart-drawer-upsell[data-toggle="true"]');
  if (!cartDrawerGiftEls.length && !dataToggleTrueEls.length) return;
  const selectedGiftsMap = {};
  cartDrawerGiftEls.forEach((cartDrawerGiftEl) => {
    if (
      cartDrawerGiftEl.dataset.handle &&
      cartDrawerGiftEl.dataset.id &&
      cartDrawerGiftEl.dataset.selected === 'true'
    ) {
      selectedGiftsMap[cartDrawerGiftEl.dataset.handle] = cartDrawerGiftEl.dataset.id;
    }
  });
  const selectedUpsellsMap = {};
  dataToggleTrueEls.forEach((dataToggleTrueEl) => {
    if (
      dataToggleTrueEl.dataset.handle &&
      dataToggleTrueEl.dataset.id &&
      dataToggleTrueEl.dataset.selected === 'true'
    ) {
      selectedUpsellsMap[dataToggleTrueEl.dataset.handle] = dataToggleTrueEl.dataset.id;
    }
  });
  if (validateSingleQuantityCartItems(cartItemsEl, selectedGiftsMap)) return;
  if (validateSingleQuantityCartItems(cartItemsEl, selectedUpsellsMap)) return;
}
function removeLocalStorageGift(gift_handle) {
  const storedGiftsRaw = localStorage.getItem('shrine_gift_goals');
  if (storedGiftsRaw)
    try {
      const storedGifts = JSON.parse(storedGiftsRaw);
      if (storedGifts && storedGifts[gift_handle.gift_handle]) {
        delete storedGifts[gift_handle.gift_handle];
        localStorage.setItem('shrine_gift_goals', JSON.stringify(storedGifts));
      }
    } catch (error) {
      console.warn('Error parsing gift localStorage data:', error);
    }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.dataset.handle) {
        const handle = this.dataset.handle;
        const relatedUpsellEls = document.querySelectorAll(
          '.quantity-break__upsell[data-handle="' + this.dataset.handle + '"]',
        );
        relatedUpsellEls.forEach((item) => {
          item.dataset.selected = 'false';
          item.classList.remove('quantity-break__upsell--selected');
          const inputTypeCheckboxEl = item.querySelector('input[type="checkbox"]');
          if (inputTypeCheckboxEl) inputTypeCheckboxEl.checked = false;
        });
      }
      const cartItemsEl = this.closest('cart-items') || this.closest('cart-drawer-items');
      this.clearCart ? cartItemsEl.clearCart() : cartItemsEl.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);
var date = '2027-10-10';
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemContainer = formatDates(currentDate, '2027-10-10');
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');
    this.secondCartItems = document.querySelector('cart-drawer-items');
    this.quantityGifts = document.querySelector('.quantity-gifts');
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', debouncedOnChange.bind(this));
    this.isCartPage = this.nodeName === 'CART-ITEMS';
    this.otherCartItemsSelector = this.isCartPage ? 'cart-drawer-items' : 'cart-items';
    this.hasOtherCartItems = document.querySelector(this.otherCartItemsSelector) !== null;
    if (this.hasOtherCartItems) {
      if (this.isCartPage) initShrineGiftsCheck(true);
    } else initShrineGiftsCheck(false);
  }
  ['cartUpdateUnsubscriber'] = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe('cart-update', (source) => {
      if (source.source === 'cart-items') return;
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
    );
  }
  onCartUpdate() {
    fetch('/cart?section_id=main-cart-items')
      .then((response) => response.text())
      .then((result) => {
        const querySelector = new DOMParser().parseFromString(result, 'text/html');
        const cartItemsEl = querySelector.querySelector('cart-items');
        this.innerHTML = cartItemsEl.innerHTML;
      })
      .catch((error) => {
        console.error(error);
      });
  }
  updateCart() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: body,
    })
      .then((response) => response.json())
      .then((result) => {
        this.classList.toggle('is-empty', result.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const targetEl =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          targetEl.innerHTML = this.getSectionInnerHTML(result.sections[section.section], section.selector);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }
  async updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const cartErrorsEl =
      document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (cartErrorsEl) cartErrorsEl.textContent = '';
    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    try {
      const response = await fetch('' + routes.cart_change_url, {
        ...fetchConfig(),
        ...{
          body: body,
        },
      });
      const responseText = await response.text();
      const cartData = JSON.parse(responseText);
      const quantityInputEl =
        document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
      const cartItemEls = document.querySelectorAll('.cart-item');
      if (cartData.errors) {
        quantityInputEl.value = quantityInputEl.getAttribute('value');
        this.updateLiveRegions(line, cartData.errors);
        return;
      }
      if (!cartData.sections) {
        const sectionsResponse = await fetch(
          routes.cart_url +
            '?sections=' +
            this.getSectionsToRender()
              .map((section) => section.section)
              .join(','),
        );
        cartData.sections = await sectionsResponse.json();
      }
      this.classList.toggle('is-empty', cartData.item_count === 0);
      const cartDrawerEl = document.querySelector('cart-drawer');
      const mainCartFooterEl = document.getElementById('main-cart-footer');
      if (mainCartFooterEl) mainCartFooterEl.classList.toggle('is-empty', cartData.item_count === 0);
      if (cartDrawerEl) cartDrawerEl.classList.toggle('is-empty', cartData.item_count === 0);
      this.getSectionsToRender().forEach((section) => {
        const sectionEl = document.getElementById(section.id);
        if (sectionEl) {
          const sectionContentEl = sectionEl.querySelector(section.selector) || sectionEl;
          sectionContentEl.innerHTML = this.getSectionInnerHTML(
            cartData.sections[section.section],
            section.selector,
          );
          const cartDrawerBodyEl = sectionContentEl.querySelector('.cart-drawer__body');
          if (cartDrawerBodyEl && this.cartDrawer) cartDrawerBodyEl.scrollTop = this.cartDrawer.cartBodyScroll;
        }
      });
      const previousQuantity = cartData.items[line - 1] ? cartData.items[line - 1].quantity : undefined;
      let errorMessage = '';
      if (cartItemEls.length === cartData.items.length && previousQuantity !== parseInt(quantityInputEl.value)) {
        typeof previousQuantity === 'undefined'
          ? (errorMessage = window.cartStrings.error)
          : (errorMessage = window.cartStrings.quantityError.replace('[quantity]', previousQuantity));
      }
      this.updateLiveRegions(line, errorMessage);
      const lineItemEl =
        document.getElementById('CartItem-' + line) || document.getElementById('CartDrawer-Item-' + line);
      if (lineItemEl && lineItemEl.querySelector('[name="' + name + '"]'))
        cartDrawerEl
          ? trapFocus(cartDrawerEl, lineItemEl.querySelector('[name="' + name + '"]'))
          : lineItemEl.querySelector('[name="' + name + '"]').focus();
      else {
        if (cartData.item_count === 0 && cartDrawerEl)
          trapFocus(cartDrawerEl.querySelector('.drawer__inner-empty'), cartDrawerEl.querySelector('a'));
        else if (document.querySelector('.cart-item') && cartDrawerEl) {
          trapFocus(cartDrawerEl, document.querySelector('.cart-item__name'));
        }
      }
      if (cartDrawerEl) {
        cartDrawerEl.checkForClear();
        const countdownTimerEl = cartDrawerEl.querySelector('countdown-timer');
        if (countdownTimerEl) countdownTimerEl.playTimer();
        let giftHandled = false;
        if (cartDrawerEl.querySelector('cart-drawer-gift')) {
          cartDrawerEl.checkForClear();
          let giftsToAdd = [];
          let giftsToRemove = [];
          cartDrawerEl.querySelectorAll('cart-drawer-gift').forEach((giftEl) => {
            if (giftEl.getUpdateRequired()) {
              cartDrawerEl.querySelector('.cart-item--product-' + giftEl.dataset.handle)
                ? giftEl.dataset.selected === 'false' && giftsToRemove.push(giftEl)
                : giftEl.dataset.selected === 'true' && giftsToAdd.push(giftEl);
            }
          });
          if (giftsToRemove.length > 0) {
            giftHandled = true;
            giftsToRemove[0].removeFromCart();
          } else if (giftsToAdd.length > 0) {
            giftHandled = true;
            giftsToAdd[0].addToCart();
          }
        }
        if (this.quantityGifts && !giftHandled) {
          this.quantityGifts.initUnlock();
        }
        const quantityBreakUpsellEls = document.querySelectorAll('quantity-break-upsells');
        quantityBreakUpsellEls.forEach((item) => {
          if (!giftHandled) item.initUnlock();
        });
      }
      publish('cart-update', {
        source: 'cart-items',
        cartData: cartData,
      });
    } catch (error) {
      console.log(error);
      this.querySelectorAll('.loading-overlay').forEach((element) =>
        element.classList.add('hidden'),
      );
      const cartErrorsEl2 =
        document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      cartErrorsEl2.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line);
      if (this.secondCartItems && this.secondCartItems.updateCart)
        this.secondCartItems.updateCart();
      const cartQuantityUpdatedEvent = new CustomEvent('cartQuantityUpdated', {
        detail: {
          handle: 'handle',
        },
      });
      document.dispatchEvent(cartQuantityUpdatedEvent);
      if (shouldCheckShrineGifts) checkShrineGifts(this.isCartPage);
      validateCartGifts(this.isCartPage);
    }
  }
  updateLiveRegions(line, innerHTML) {
    const lineItemErrorEl =
      document.getElementById('Line-item-error-' + line) ||
      document.getElementById('CartDrawer-LineItemError-' + line);
    if (lineItemErrorEl) lineItemErrorEl.querySelector('.cart-item__error-text').innerHTML = innerHTML;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const liveRegionEl =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    liveRegionEl.setAttribute('aria-hidden', false);
    setTimeout(() => {
      liveRegionEl.setAttribute('aria-hidden', true);
    }, 1000);
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  enableLoading(line) {
    const cartItemsContainerEl =
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    cartItemsContainerEl.classList.add('cart__items--disabled');
    const items = this.querySelectorAll('#CartItem-' + line + ' .loading-overlay');
    const items2 = this.querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay');
    [...items, ...items2].forEach((overlayEl) => overlayEl.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }
  disableLoading(line) {
    const cartItemsContainerEl =
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    cartItemsContainerEl.classList.remove('cart__items--disabled');
    const items = this.querySelectorAll('#CartItem-' + line + ' .loading-overlay');
    const items2 = this.querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay');
    items.forEach((item) => item.classList.add('hidden'));
    items2.forEach((item) => item.classList.add('hidden'));
  }
  clearCart() {
    const cartErrorsEl =
      document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (cartErrorsEl) cartErrorsEl.textContent = '';
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch('' + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        body: body,
      },
    })
      .then((response) => {
        return response.text();
      })
      .then(async (result) => {
        const parsedData = JSON.parse(result);
        if (!parsedData.sections)
          try {
            const sectionIds = this.getSectionsToRender()
              .map((id) => id.id)
              .join(',');
            const sectionsResponse = await fetch(routes.cart_url + '?sections=' + sectionIds);
            const sectionsText = await sectionsResponse.text();
            try {
              const sectionsData = JSON.parse(sectionsText);
              parsedData.sections = sectionsData;
            } catch (error) {
              console.error('Clear cart fallback JSON parse failed', error);
              window.location.reload();
              return;
            }
          } catch (error) {
            console.error('Clear cart fallback failed', error);
            throw error;
          }
        this.classList.add('is-empty');
        const cartDrawerEl = document.querySelector('cart-drawer');
        const mainCartFooterEl = document.getElementById('main-cart-footer');
        if (mainCartFooterEl) mainCartFooterEl.classList.add('is-empty');
        if (cartDrawerEl) cartDrawerEl.classList.add('is-empty');
        this.getSectionsToRender().forEach((section) => {
          const targetEl =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          targetEl.innerHTML = this.getSectionInnerHTML(parsedData.sections[section.section], section.selector);
        });
        if (cartDrawerEl) {
          trapFocus(
            cartDrawerEl.querySelector('.drawer__inner-empty'),
            cartDrawerEl.querySelector('a'),
          );
        }
        publish('cart-update', {
          source: 'cart-items',
        });
        if (shouldCheckShrineGifts) checkShrineGifts(this.isCartPage);
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((element) =>
          element.classList.add('hidden'),
        );
        const cartErrorsEl3 =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors');
        cartErrorsEl3.textContent = window.cartStrings.error;
      });
  }
}
customElements.define('cart-items', CartItems);
var search = 'search';
if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({
              note: event.target.value,
            });
            fetch('' + routes.cart_update_url, {
              ...fetchConfig(),
              ...{
                body: body,
              },
            });
          }, 300),
        );
      }
    },
  );
}
function handleDiscountForm(event) {
  event.preventDefault();
  const cartDiscountFieldEl = event.target.querySelector('[name=cart-discount-field]');
  const discountFormErrorEl = event.target.querySelector('.cart-discount-form__error');
  const discountValue = cartDiscountFieldEl.value;
  if (cartDiscountFieldEl.value === undefined || cartDiscountFieldEl.value.length === 0) {
    discountFormErrorEl.style.display = 'block';
    return;
  }
  discountFormErrorEl.style.display = 'none';
  const checkoutDiscountBase = '/checkout?discount=';
  const href = '/checkout?discount=' + cartDiscountFieldEl.value;
  window.location.href = href;
}
function handleDiscountFormChange(event) {
  const discountFormErrorEls = document.querySelectorAll('.cart-discount-form__error');
  discountFormErrorEls.forEach((discountFormErrorEl) => {
    discountFormErrorEl.style.display = 'none';
  });
}
var serial = '';
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.dataset.main === 'false') serial = this.querySelector('[method="get"]').dataset.modal;
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }
  }
  toggleResetButton() {
    const isHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && isHidden) this.resetButton.classList.remove('hidden');
    else if (this.input.value.length === 0 && !isHidden) {
      this.resetButton.classList.add('hidden');
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define('search-form', SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const searchTerm = this.getQuery();
    if (!this.searchTerm || !searchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, searchTerm);
    this.searchTerm = searchTerm;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a'))
      event.preventDefault();
  }
  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }
  onFocus() {
    const items = this.getQuery();
    if (!items.length) return;
    if (this.searchTerm !== items) this.onChange();
    else
      this.getAttribute('results') === 'true'
        ? this.open()
        : this.getSearchResults(this.searchTerm);
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }
  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextEl = this.querySelector('[data-predictive-search-search-for-text]');
    const text = searchForTextEl?.innerText;
    if (text) {
      if (text.match(new RegExp(previousTerm, 'g')).length > 1) return;
      const updatedText = text.replace(previousTerm, newTerm);
      searchForTextEl.innerText = updatedText;
    }
  }
  switchOption(type) {
    if (!this.getAttribute('open')) return;
    const isUp = type === 'up';
    const ariaSelectedTrueEl = this.querySelector('[aria-selected="true"]');
    const items = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (offsetParent) => offsetParent.offsetParent !== null,
    );
    let newIndex = 0;
    if (isUp && !ariaSelectedTrueEl) return;
    let currentIndex = -1;
    let loopIndex = 0;
    while (currentIndex === -1 && loopIndex <= items.length) {
      if (items[loopIndex] === ariaSelectedTrueEl) {
        currentIndex = loopIndex;
      }
      loopIndex++;
    }
    this.statusElement.textContent = '';
    if (!isUp && ariaSelectedTrueEl) newIndex = currentIndex === items.length - 1 ? 0 : currentIndex + 1;
    else if (isUp) {
      newIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
    }
    if (newIndex === currentIndex) return;
    const newItem = items[newIndex];
    items[newIndex].setAttribute('aria-selected', true);
    if (ariaSelectedTrueEl) ariaSelectedTrueEl.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', items[newIndex].id);
  }
  selectOption() {
    const aEl = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (aEl) aEl.click();
  }
  getSearchResults(text) {
    const cacheKey = text.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[cacheKey]) {
      this.renderSearchResults(this.cachedResults[cacheKey]);
      return;
    }
    fetch(
      routes.predictive_search_url +
        '?q=' +
        encodeURIComponent(text) +
        '&section_id=predictive-search',
      {
        signal: this.abortController.signal,
      },
    )
      .then((response) => {
        if (!response.ok) {
          var statusError = new Error(response.status);
          this.close();
          throw statusError;
        }
        return response.text();
      })
      .then((result) => {
        const sectionHtml = new DOMParser()
          .parseFromString(result, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.allPredictiveSearchInstances.forEach((allPredictiveSearchInstance) => {
          allPredictiveSearchInstance.cachedResults[cacheKey] = new DOMParser()
            .parseFromString(result, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;
        });
        this.renderSearchResults(
          new DOMParser()
            .parseFromString(result, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML,
        );
      })
      .catch((error) => {
        if (error?.code === 20) return;
        this.close();
        throw error;
      });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }
  setLiveRegionText(statusElement) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusElement;
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }
  renderSearchResults(predictiveSearchResults) {
    this.predictiveSearchResults.innerHTML = predictiveSearchResults;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(
      this.querySelector('[data-predictive-search-live-region-count-value]').textContent,
    );
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || this.getResultsMaxHeight() + 'px';
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }
  close(shouldReset = false) {
    this.closeResults(shouldReset);
    this.isOpen = false;
  }
  closeResults(shouldReset = false) {
    if (shouldReset) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const ariaSelectedTrueEl = this.querySelector('[aria-selected="true"]');
    if (ariaSelectedTrueEl) ariaSelectedTrueEl.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}
customElements.define('predictive-search', PredictiveSearch);
const defMed = 'data-defer';
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.quantityGifts = document.querySelector('.quantity-gifts');
    this.checkForClear();
    this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.cartBodyScroll = 0;
  }
  setHeaderCartIconAccessibility() {
    let cartIconBubbleEl = document.querySelector('#cart-icon-bubble');
    if (!cartIconBubbleEl) return;
    if (cartIconBubbleEl.tagName == 'DIV')
      cartIconBubbleEl = cartIconBubbleEl.closest('.header__icon--cart');
    if (!cartIconBubbleEl) return;
    const headerIconsEl = cartIconBubbleEl.closest('.header__icons');
    cartIconBubbleEl.setAttribute('role', 'button');
    cartIconBubbleEl.setAttribute('aria-haspopup', 'dialog');
    cartIconBubbleEl.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartIconBubbleEl);
    });
    this.oseid = headerIconsEl.querySelector('form').dataset[this.dataset.type];
    cartIconBubbleEl.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartIconBubbleEl);
      }
    });
  }
  open(activeElement) {
    if (activeElement) this.setActiveElement(activeElement);
    const summaryEl = this.querySelector('[id^="Details-"] summary');
    if (summaryEl && !summaryEl.hasAttribute('role')) this.setSummaryAccessibility(summaryEl);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    this.addEventListener(
      'transitionend',
      () => {
        const focusContainerEl = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusTargetEl = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(focusContainerEl, focusTargetEl);
      },
      {
        once: true,
      },
    );
    document.body.classList.add('overflow-hidden');
    const countdownTimerEl = this.querySelector('countdown-timer');
    if (countdownTimerEl) countdownTimerEl.playTimer();
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  getUpsellHandles() {
    const dataToggleTrueEls = this.querySelectorAll(
      'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
    );
    const handles = [];
    dataToggleTrueEls.forEach((dataToggleTrueEl) => {
      if (dataToggleTrueEl.dataset.handle) {
        handles.push(dataToggleTrueEl.dataset.handle);
      }
    });
    return handles;
  }
  oneNonUpellRemaining() {
    const cartItemEls = this.querySelectorAll('.cart-item');
    let matchCount = 0;
    cartItemEls.forEach((cartItemEl) => {
      this.upsellHandles.forEach((upsellHandle) => {
        if (cartItemEl.classList.contains('cart-item--product-' + upsellHandle)) {
          matchCount++;
        }
      });
    });
    return cartItemEls.length - matchCount <= 1;
  }
  checkForClear() {
    const shouldClear = this.oneNonUpellRemaining();
    this.querySelectorAll('cart-remove-button').forEach((clearCart) => {
      shouldClear ? (clearCart.clearCart = true) : (clearCart.clearCart = false);
    });
  }
  setSummaryAccessibility(element) {
    element.setAttribute('role', 'button');
    element.setAttribute('aria-expanded', 'false');
    if (element.nextElementSibling.getAttribute('id')) {
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    }
    element.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open'),
      );
    });
    element.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(cartData, skipOpen = false) {
    if (this.querySelector('.drawer__inner').classList.contains('is-empty')) {
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    }
    this.productId = cartData.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionEl = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionEl) {
        sectionEl.innerHTML = this.getSectionInnerHTML(cartData.sections[section.id], section.selector);
        const cartDrawerBodyEl = sectionEl.querySelector('.cart-drawer__body');
        if (cartDrawerBodyEl) cartDrawerBodyEl.scrollTop = this.cartBodyScroll;
      }
    });
    this.checkForClear();
    const countdownTimerEl = this.querySelector('countdown-timer');
    if (countdownTimerEl && countdownTimerEl.playTimer) countdownTimerEl.playTimer();
    let giftsToAdd = [];
    let giftsToRemove = [];
    this.querySelectorAll('cart-drawer-gift').forEach((giftEl) => {
      if (giftEl.getUpdateRequired()) {
        this.querySelector('.cart-item--product-' + giftEl.dataset.handle)
          ? giftEl.dataset.selected === 'false' && giftsToRemove.push(giftEl)
          : giftEl.dataset.selected === 'true' && giftsToAdd.push(giftEl);
      }
    });
    if (giftsToRemove.length > 0) giftsToRemove[0].removeFromCart();
    else {
      if (giftsToAdd.length > 0) giftsToAdd[0].addToCart();
      else {
        if (this.quantityGifts) this.quantityGifts.initUnlock();
        const quantityBreakUpsellEls = document.querySelectorAll('quantity-break-upsells');
        quantityBreakUpsellEls.forEach((item) => {
          item.initUnlock();
        });
      }
    }
    validateCartGifts();
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (skipOpen) return;
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    let sectionEl = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (selector === '#CartDrawer') {
      fixParsedHtml(this, sectionEl);
    }
    let innerHTML = sectionEl.innerHTML;
    return sectionEl.innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(activeElement) {
    this.activeElement = activeElement;
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector('cart-drawer');
    this.secondCartItems = document.querySelector('cart-items');
  }
  updateCart() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {},
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        document.querySelector('cart-drawer').renderContents(result, true);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  getSectionInnerHTML(html, selector) {
    let sectionEl = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (selector === '.drawer__inner') {
      fixParsedHtml(this.cartDrawer, sectionEl);
    }
    let innerHTML = sectionEl.innerHTML;
    return sectionEl.innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
function fixParsedHtml(oldEl, newEl) {
  const cartDrawerBodyEl = oldEl.querySelector('.cart-drawer__body');
  if (cartDrawerBodyEl) {
    const cartDrawerEl = document.querySelector('cart-drawer');
    cartDrawerEl.cartBodyScroll = cartDrawerBodyEl.scrollTop;
  }
  const cartTimerEl = newEl.querySelector('.cart-timer');
  if (cartTimerEl) {
    oldTimer = oldEl.querySelector('.cart-timer');
    if (oldTimer) cartTimerEl.innerHTML = oldTimer.innerHTML;
  }
  const dataToggleTrueEls = oldEl.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
  );
  let dataToggleTrueEls2 = newEl.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift',
  );
  dataToggleTrueEls.forEach((dataToggleTrueEl, index) => {
    let newToggleEl = dataToggleTrueEls2[index];
    if (!dataToggleTrueEls2[index]) return;
    if (dataToggleTrueEl.nodeName.toLowerCase() === 'cart-drawer-upsell')
      dataToggleTrueEls2[index].dataset.selected = dataToggleTrueEl.dataset.selected;
    dataToggleTrueEls2[index].dataset.id = dataToggleTrueEl.dataset.id;
    dataToggleTrueEls2[index].querySelector('[name="id"]').value =
      dataToggleTrueEl.querySelector('[name="id"]').value;
    if (dataToggleTrueEls2[index].querySelector('.upsell__image__img'))
      dataToggleTrueEls2[index].querySelector('.upsell__image__img').src =
        dataToggleTrueEl.querySelector('.upsell__image__img').src;
    if (dataToggleTrueEls2[index].querySelector('.upsell__variant-picker')) {
      const oldSelectEls = dataToggleTrueEl.querySelectorAll('.select__select');
      dataToggleTrueEls2[index]
        .querySelectorAll('.select__select')
        .forEach((newSelectEl, selectIndex) => {
          newSelectEl.value = oldSelectEls[selectIndex].value;
          newSelectEl.querySelectorAll('option').forEach((optionEl) => {
            optionEl.removeAttribute('selected');
            if (optionEl.value === oldSelectEls[selectIndex].value.trim()) optionEl.setAttribute('selected', '');
          });
        });
    }
    if (dataToggleTrueEl.dataset.updatePrices === 'true') {
      var upsellPriceEl = dataToggleTrueEls2[index].querySelector('.upsell__price');
      var upsellPriceEl2 = dataToggleTrueEl.querySelector('.upsell__price');
      if (upsellPriceEl && upsellPriceEl2) upsellPriceEl.innerHTML = upsellPriceEl2.innerHTML;
    }
  });
}
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.formIdInput = this.form.querySelector('[name=id]');
        this.formIdInput.disabled = false;
        this.isMain = this.classList.contains('main-product-form');
        this.additionalAtcButtons = this.isMain
          ? document.querySelectorAll('.main-product-atc')
          : [];
        this.skipCart = this.formIdInput.dataset.skipCart === 'true';
        this.cart =
          document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.isCartUpsell = this.dataset.isCartUpsell === 'true';
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) {
          if (this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
          this.hasDrawer = true;
        }
        if (this.submitButton)
          this.loadingSpinner = this.submitButton.querySelector('.loading-overlay__spinner');
        this.displayedSubmitButton = document.getElementById(
          'DisplayedSubmitBtn-' + this.dataset.section,
        );
        this.bundleDeals = document.getElementById('bundle-deals-' + this.dataset.section);
        this.productInfo = document.getElementById('ProductInfo-' + this.dataset.section);
        this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
        if (this.quantityBreaks)
          this.quantityBreakUpsells =
            this.quantityBreaks.querySelectorAll('quantity-break-upsells');
        this.quantityPicker = document.getElementById('Quantity-Form-' + this.dataset.section);
        this.customFields = document.querySelectorAll(
          "[id^='CustomField-" + this.dataset.section + "-']",
        );
        this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section);
        this.mainBundleItems = document.querySelectorAll(
          '.main-offer-item-' + this.dataset.section,
        );
        this.variantInputs = this.form.querySelector('.product-form__variants');
      }
      handleSubmit(event) {
        let spinnerButtonEl = null;
        let skipCartButton = false;
        if (event) {
          event.preventDefault();
          if (event.currentTarget.classList.contains('button--has-spinner')) {
            spinnerButtonEl = event.currentTarget;
            spinnerButtonEl.classList.add('loading');
          }
          if (event.currentTarget.dataset.skipCartButton === 'true') {
            skipCartButton = true;
          }
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        if (!spinnerButtonEl) {
          this.submitButton.classList.add('loading');
          if (this.loadingSpinner) this.loadingSpinner.classList.remove('hidden');
        }
        this.additionalAtcButtons.forEach((additionalAtcButton) => {
          additionalAtcButton.setAttribute('disabled', '');
        });
        if (this.displayedSubmitButton) {
          this.displayedSubmitButton.setAttribute('disabled', '');
          this.displayedSubmitButton.classList.add('loading');
        }
        let hasCustomItems = false;
        let usedBundleFormVariants = false;
        if (this.variantInputs && !this.ref) {
          this.variantInputs.innerHTML = '';
          let hiddenInputsHtml = '';
          const lineItems = [];
          const lineItemIdsWithProperties = new Set();
          const normalizeValue = (str) => {
            const trimmed = str == null ? '' : String(str).trim();
            return trimmed === '' ? null : trimmed;
          };
          const addLineItem = (str, value = 1, sellingPlanRaw = null) => {
            if (!str) return;
            const idStr = String(str);
            const qty = Number(value) || 1;
            const selling_plan = normalizeValue(sellingPlanRaw);
            const existingIndex = lineItems.findIndex((lineItem) => {
              const existingSellingPlan = normalizeValue(lineItem.selling_plan);
              return lineItem.id === idStr && existingSellingPlan === selling_plan;
            });
            if (existingIndex === -1) {
              const newLineItem = {
                id: idStr,
                quantity: qty,
              };
              if (selling_plan) newLineItem.selling_plan = selling_plan;
              lineItems.push(newLineItem);
            } else lineItems[existingIndex].quantity += qty;
          };
          const markHasProperties = (str) => {
            if (str) lineItemIdsWithProperties.add(String(str));
          };
          if (this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
            this.cart
              .querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
              .forEach((cartUpsellEl) => {
                if (
                  cartUpsellEl.dataset.selected === 'true' &&
                  !this.cart.querySelector('.cart-item--product-' + cartUpsellEl.dataset.handle)
                ) {
                  const sellingPlanValue =
                    cartUpsellEl.querySelector('input[name="selling_plan"]')?.value || null;
                  addLineItem(cartUpsellEl.dataset.id, 1, sellingPlanValue);
                }
              });
          }
          if (this.bundleDeals) {
            if (this.dataset.includePdpUpsells === 'true') {
              document.querySelectorAll('product-info-upsell').forEach((pdpUpsellEl) => {
                const sellingPlanValue = pdpUpsellEl.querySelector('input[name="selling_plan"]')?.value || null;
                if (pdpUpsellEl.dataset.selected === 'true') addLineItem(pdpUpsellEl.dataset.id, 1, sellingPlanValue);
              });
            }
            (this.bundleDeals.formVariants || []).forEach((formVariant) => {
              if (!formVariant) return;
              addLineItem(formVariant.id, Number(formVariant.quantity) || 1);
            });
          } else {
            if (
              this.quantityGifts &&
              Array.isArray(this.quantityGifts.unlockedItems) &&
              this.quantityGifts.unlockedItems.length > 0
            ) {
              this.quantityGifts.unlockedItems.forEach((unlockedItem) =>
                addLineItem(unlockedItem, 1),
              );
            }
            this.upsells = document.querySelectorAll(
              '.product-info-upsell-' + this.dataset.section,
            );
            for (let upsellIndex = this.upsells.length - 1; upsellIndex >= 0; upsellIndex--) {
              const upsellEl = this.upsells[upsellIndex];
              if (this.upsells[upsellIndex] && this.upsells[upsellIndex].dataset.selected === 'true') {
                const sellingPlanValue =
                  this.upsells[upsellIndex].querySelector('input[name="selling_plan"]')?.value ||
                  null;
                addLineItem(this.upsells[upsellIndex].dataset.id, 1, sellingPlanValue);
              }
            }
            if (this.quantityBreakUpsells) {
              this.quantityBreakUpsells.forEach((quantityBreakUpsell) => {
                (quantityBreakUpsell.unlockedItems || []).forEach((str) => {
                  const itemIdStr = String(str);
                  if (!lineItems.some((item) => String(item.id) === itemIdStr)) {
                    addLineItem(itemIdStr, 1);
                  }
                });
              });
            }
            if (this.mainBundleItems.length === 0) {
              if (
                this.quantityBreaks &&
                Array.isArray(this.quantityBreaks.formVariants) &&
                this.quantityBreaks.formVariants.length > 0
              ) {
                this.quantityBreaks.formVariants.forEach((formVariant) => {
                  addLineItem(formVariant, 1);
                  markHasProperties(formVariant);
                });
                usedBundleFormVariants = true;
              } else {
                let quantity = 1;
                if (this.quantityBreaks)
                  quantity = Number(this.quantityBreaks.selectedQuantity) || 1;
                else {
                  if (this.quantityPicker)
                    quantity =
                      Number(this.quantityPicker.querySelector('.quantity__input')?.value) || 1;
                  else if (this.querySelector('input[name="quantity"]')) {
                    quantity = Number(this.querySelector('input[name="quantity"]').value) || 1;
                  }
                }
                const formIdValue = this.formIdInput.value;
                addLineItem(this.formIdInput.value, quantity);
                markHasProperties(this.formIdInput.value);
              }
            }
            for (let bundleIndex = this.mainBundleItems.length - 1; bundleIndex >= 0; bundleIndex--) {
              const bundleItemEl = this.mainBundleItems[bundleIndex];
              addLineItem(this.mainBundleItems[bundleIndex].dataset.id, 1);
              if (
                this.mainBundleItems[bundleIndex].dataset.isMainPdpProduct === undefined ||
                this.mainBundleItems[bundleIndex].dataset.isMainPdpProduct === 'true'
              ) {
                markHasProperties(this.mainBundleItems[bundleIndex].dataset.id);
              }
            }
          }
          if (lineItems.length > 1 || usedBundleFormVariants || this.bundleDeals || this.mainBundleItems.length > 0) {
            const customFieldsData = [];
            this.customFields?.forEach((customFieldEl) => {
              if (customFieldEl?.dataset?.disabled !== 'true') {
                customFieldsData.push({
                  fieldName: customFieldEl.fieldName,
                  value: customFieldEl.prevValue,
                });
              }
            });
            let sellingPlanInputEl = null;
            if (this.classList.contains('main-product-form')) {
              sellingPlanInputEl =
                this.querySelector('.appstle-active-option [name="selling_plan"]') ||
                this.querySelector('[name="selling_plan"]') ||
                document.querySelector(
                  '.sls-purchase [name="selling_plan"], skio-plan-picker [name="selling_plan"]',
                );
            }
            const simpleBundlesOptionsEl = this.querySelector('#simple-bundles-io-options');
            const propertiesSelector =
              'input[name^="properties["]:not(#validator):not(.shrine-property-input):not([type="radio"]),input[name^="properties["][type="radio"]:checked:not(#validator):not(.shrine-property-input),select[name^="properties["]:not(#validator):not(.shrine-property-input)';
            const propertyInputEls = this.classList.contains('main-product-form')
              ? this.productInfo
                ? this.productInfo.querySelectorAll(
                    'input[name^="properties["]:not(#validator):not(.shrine-property-input):not([type="radio"]),input[name^="properties["][type="radio"]:checked:not(#validator):not(.shrine-property-input),select[name^="properties["]:not(#validator):not(.shrine-property-input)',
                  )
                : document.querySelectorAll(
                    'input[name^="properties["]:not(#validator):not(.shrine-property-input):not([type="radio"]),input[name^="properties["][type="radio"]:checked:not(#validator):not(.shrine-property-input),select[name^="properties["]:not(#validator):not(.shrine-property-input)',
                  )
              : [];
            lineItems.forEach((lineItem) => {
              if (lineItemIdsWithProperties.has(lineItem.id)) {
                const itemProperties = [];
                customFieldsData.forEach((customFieldData) => {
                  itemProperties.push({
                    fieldName: customFieldData.fieldName,
                    value: customFieldData.value,
                  });
                });
                if (simpleBundlesOptionsEl) {
                  simpleBundlesOptionsEl
                    .querySelectorAll('select[name^="properties["], input[name^="properties["]')
                    .forEach((bundleOptionEl) => {
                      const propertyNameMatch = bundleOptionEl.name.match(/properties\[(.*?)\]/);
                      if (propertyNameMatch)
                        itemProperties.push({
                          fieldName: propertyNameMatch[1],
                          value: bundleOptionEl.value,
                        });
                    });
                }
                if (this.classList.contains('main-product-form')) {
                  propertyInputEls.forEach((propertyInputEl) => {
                    const propertyNameMatch = propertyInputEl.name.match(/properties\[(.*?)\]/);
                    if (propertyNameMatch) {
                      propertyInputEl.type === 'file'
                        ? propertyInputEl.files &&
                          propertyInputEl.files.length > 0 &&
                          itemProperties.push({
                            fieldName: propertyNameMatch[1],
                            value: propertyInputEl.files[0],
                            isFile: true,
                          })
                        : itemProperties.push({
                            fieldName: propertyNameMatch[1],
                            value: propertyInputEl.value,
                          });
                    }
                  });
                }
                if (itemProperties.length) lineItem.properties = itemProperties;
                if (
                  sellingPlanInputEl &&
                  typeof sellingPlanInputEl.value === 'string' &&
                  sellingPlanInputEl.value.length > 0
                ) {
                  lineItem.selling_plan = sellingPlanInputEl.value;
                }
              }
            });
            const hiddenInputsFragment = document.createDocumentFragment();
            const fileProperties = [];
            lineItems.forEach((lineItem, index) => {
              hiddenInputsHtml +=
                '<input type="hidden" name="items[' +
                index +
                '][quantity]" value="' +
                lineItem.quantity +
                '">' +
                ('<input type="hidden" name="items[' + index + '][id]" value="' + lineItem.id + '">');
              if (lineItem.selling_plan) {
                hiddenInputsHtml +=
                  '<input type="hidden" name="items[' +
                  index +
                  '][selling_plan]" value="' +
                  lineItem.selling_plan +
                  '">';
              }
              if (Array.isArray(lineItem.properties) && lineItem.properties.length) {
                lineItem.properties.forEach((propertie) => {
                  if (propertie.isFile)
                    fileProperties.push({
                      name: 'items[' + index + '][properties][' + propertie.fieldName + ']',
                      file: propertie.value,
                    });
                  else {
                    const hiddenInputEl = document.createElement('input');
                    hiddenInputEl.type = 'hidden';
                    hiddenInputEl.name =
                      'items[' + index + '][properties][' + propertie.fieldName + ']';
                    hiddenInputEl.value = serializePropValue(propertie.value);
                    hiddenInputsFragment.appendChild(hiddenInputEl);
                  }
                });
              }
            });
            this._filePropsForFormData = fileProperties;
            this.variantInputs.innerHTML = hiddenInputsHtml;
            this.variantInputs.appendChild(hiddenInputsFragment);
            hasCustomItems = true;
          }
        }
        var fetchConfigObj = fetchConfig('javascript');
        fetchConfigObj.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete fetchConfigObj.headers['Content-Type'];
        var body = new FormData(this.form);
        if (this._filePropsForFormData && this._filePropsForFormData.length > 0) {
          this._filePropsForFormData.forEach(({ name: fileName, file: fileValue }) => {
            body.append(fileName, fileValue);
          });
          this._filePropsForFormData = [];
        }
        if (this.ref) hasCustomItems = true;
        if (this.cart) {
          body.append(
            'sections',
            this.cart.getSectionsToRender().map((id) => id.id),
          );
          body.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (hasCustomItems) {
          const excludedOptionKeys = this.dataset.options ? this.dataset.options.split(',') : [];
          const excludedFormKeys = ['id', 'quantity', ...excludedOptionKeys];
          for (let keyIndex = 0; keyIndex < excludedFormKeys.length; keyIndex++) {
            body.delete(excludedFormKeys[keyIndex]);
          }
        }
        fetchConfigObj.body = body;
        fetch('' + routes.cart_add_url, fetchConfigObj)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              const soldOutMessageEl = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessageEl) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessageEl.classList.remove('hidden');
              this.error = true;
              return;
            }
            if (!response.sections && this.cart)
              try {
                const sectionsResponse = await fetch(
                  routes.cart_url +
                    '?sections=' +
                    this.cart
                      .getSectionsToRender()
                      .map((id) => id.id)
                      .join(','),
                );
                const sectionsText = await sectionsResponse.text();
                try {
                  const sectionsData = JSON.parse(sectionsText);
                  response.sections = sectionsData;
                } catch (error) {
                  console.error('Add to cart fallback JSON parse failed', error);
                  window.location = window.routes.cart_url;
                  return;
                }
              } catch (error) {
                console.error('Add to cart fallback failed', error);
                this.handleErrorMessage(window.cartStrings.error || 'Something went wrong.');
                return;
              }
            if (this.skipCart || skipCartButton) {
              window.location = '/checkout';
              return;
            } else {
              if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
            }
            if (!this.error)
              publish('cart-update', {
                source: 'product-form',
                productVariantId: this.formIdInput.id,
                cartData: response,
              });
            this.error = false;
            const quickAddModalEl = this.closest('quick-add-modal');
            quickAddModalEl
              ? (document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response, this.isCartUpsell);
                    });
                  },
                  {
                    once: true,
                  },
                ),
                quickAddModalEl.hide(true))
              : this.cart.renderContents(response, this.isCartUpsell);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            if (spinnerButtonEl) spinnerButtonEl.classList.remove('loading');
            else {
              this.submitButton.classList.remove('loading');
              if (this.loadingSpinner) this.loadingSpinner.classList.add('hidden');
            }
            this.additionalAtcButtons.forEach((additionalAtcButton) => {
              additionalAtcButton.removeAttribute('disabled');
            });
            if (this.displayedSubmitButton) {
              this.displayedSubmitButton.removeAttribute('disabled');
              this.displayedSubmitButton.classList.remove('loading');
            }
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
function serializePropValue(str) {
  if (str == null) return '';
  if (typeof str === 'object')
    try {
      return JSON.stringify(str);
    } catch {
      return String(str);
    }
  return String(str);
}
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.deferredMedia = document.querySelector('[data-defer]');
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.form = this.querySelector('#ProductForm-' + this.dataset.section);
        this.hasUrl = this.dataset.url !== null;
      }
      ['cartUpdateUnsubscriber'] = undefined;
      ['variantChangeUnsubscriber'] = undefined;
      connectedCallback() {
        if (!this.form) return;
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            'cart-update',
            this.fetchQuantityRules.bind(this),
          );
        }
        this.variantChangeUnsubscriber = subscribe('variant-change', (data) => {
          const sectionId = this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section;
          if (data.data.sectionId !== sectionId) return;
          this.updateQuantityRules(data.data.sectionId, data.data.html);
          this.setQuantityBoundries();
        });
      }
      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }
      setQuantityBoundries() {
        const quantityConfig = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };
        let min = quantityConfig.min;
        const max = quantityConfig.max === null ? quantityConfig.max : quantityConfig.max - quantityConfig.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (quantityConfig.cartQuantity >= quantityConfig.min) min = Math.min(min, quantityConfig.step);
        const inputValue = parseInt(this.input.value) || min;
        let input = inputValue;
        if (input < min) input = min;
        if (max !== null && input > max) input = max;
        this.input.min = min;
        this.input.max = max;
        this.input.value = input;
        publish('quantity-update', undefined);
      }
      initShareLinks() {
        const shareUrlButtonEl = this.querySelector('.share-url-button');
        if (!shareUrlButtonEl) this.shareUrl = true;
      }
      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(
          this.dataset.url +
            '?variant=' +
            this.currentVariant.value +
            '&section_id=' +
            this.dataset.section,
        )
          .then((response) => {
            return response.text();
          })
          .then((result) => {
            const parsedHtml = new DOMParser().parseFromString(result, 'text/html');
            this.updateQuantityRules(this.dataset.section, parsedHtml);
            this.setQuantityBoundries();
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }
      updateQuantityRules(sectionId, doc) {
        const quantityFormEl = doc.getElementById('Quantity-Form-' + sectionId);
        if (quantityFormEl && this.quantityForm) {
          const selectorsToSync = ['.quantity__input', '.quantity__rules', '.quantity__label'];
          for (let selector of selectorsToSync) {
            const currentEl = this.quantityForm.querySelector(selector);
            const newEl = quantityFormEl.querySelector(selector);
            if (!currentEl || !newEl) continue;
            if (selector === '.quantity__input') {
              const attrsToSync = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
              for (let attr of attrsToSync) {
                const attrValue = newEl.getAttribute(attr);
                if (attrValue !== null) currentEl.setAttribute(attr, attrValue);
              }
            } else currentEl.innerHTML = newEl.innerHTML;
          }
        }
      }
    },
  );
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((element) => {
  element.setAttribute('role', 'button');
  element.setAttribute('aria-expanded', element.parentNode.hasAttribute('open'));
  if (element.nextElementSibling?.getAttribute('id')) {
    element.setAttribute('aria-controls', element.nextElementSibling.id);
  }
  element.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
  });
  if (element.closest('header-drawer')) return;
  element.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var items = getFocusableElements(container);
  var firstFocusable = items[0];
  var lastFocusable = items[items.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== items[items.length - 1] && event.target !== items[0])
      return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === items[items.length - 1] && !event.shiftKey) {
      event.preventDefault();
      items[0].focus();
    }
    if ((event.target === container || event.target === items[0]) && event.shiftKey) {
      event.preventDefault();
      items[items.length - 1].focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((contentWindow) => {
    contentWindow.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((contentWindow) => {
    contentWindow.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('media-gallery template video').forEach((pause) => pause.pause());
  document.querySelectorAll('product-model').forEach((modelViewerUI) => {
    if (modelViewerUI.modelViewerUI) modelViewerUI.modelViewerUI.pause();
  });
}
var menuIndex = 'body';
var linkContent = 'innerHTML';
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const detailsOpenEl = event.target.closest('details[open]');
  if (!detailsOpenEl) return;
  const summaryEl = detailsOpenEl.querySelector('summary');
  detailsOpenEl.removeAttribute('open');
  summaryEl.setAttribute('aria-expanded', false);
  summaryEl.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true,
    });
    this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section);
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((element) =>
      element.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }
  ['quantityUpdateUnsubscriber'] = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      'quantity-update',
      this.validateQtyRules.bind(this),
    );
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (this.input.value !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const minValue = parseInt(this.input.min);
      const minusButtonEl = this.querySelector(".quantity__button[name='minus']");
      minusButtonEl.classList.toggle('disabled', value <= minValue);
    }
    if (this.input.max) {
      const maxValue = parseInt(this.input.max);
      const plusButtonEl = this.querySelector(".quantity__button[name='plus']");
      plusButtonEl.classList.toggle('disabled', value >= maxValue);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) this.quantityGifts.unlockGifts(value);
  }
}
customElements.define('quantity-input', QuantityInput);
function debounce(callback, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback(), wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/' + type,
    },
  };
}
function addDays(dateStr, days) {
  var newDate = new Date(dateStr);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
}
function formatDates(currentDate, dateStr, thresholdDays = 27) {
  if (!currentDate || !dateStr) return;
  const targetDate = new Date(dateStr + 'T00:00:00Z');
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth();
  const day = targetDate.getDate();
  const normalizedTargetDate = new Date(year, month, day);
  const diffMs = currentDate - normalizedTargetDate;
  const diffDays = Math.ceil(diffMs / 86400000);
  return diffDays <= thresholdDays;
}
function checkDateValidity(dateStr) {
  const getDate = new Date(dateStr);
  const getDate2 = new Date('2023-01-01T00:00:00Z');
  const diff = Math.abs(getDate.getDate() - getDate2.getDate());
  return diff % 5 === 0 ? true : false;
}
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function (apply, context) {
  return function () {
    return apply.apply(context, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, len = selector.options.length; i < len; i++) {
    var option = selector.options[i];
    if (value == selector.options[i].value || value == selector.options[i].innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (element, eventName, callback) {
  element.addEventListener
    ? element.addEventListener(eventName, callback, false)
    : element.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options.method || 'post';
  var params = options.parameters || {};
  var element = document.createElement('form');
  element.setAttribute('method', method);
  element.setAttribute('action', path);
  for (var key in params) {
    var element2 = document.createElement('input');
    element2.setAttribute('type', 'hidden');
    element2.setAttribute('name', key);
    element2.setAttribute('value', params[key]);
    element.appendChild(element2);
  }
  document.body.appendChild(element);
  element.submit();
  document.body.removeChild(element);
};
Shopify.internationalAccessAccept = (function () {
  function callback() {
    var match = navigator.language || navigator.userLanguage;
    return match.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true;
  }
  function callback2() {
    var options = {
      locale: 'en-US',
      calendar: 'gregory',
      numberingSystem: 'latn',
      timeZone: 'Asia/Saigon',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }.timeZone;
    return false || false || false;
  }
  function callback3() {
    var items = Shopify.currency.symbol || '$';
    return items.length === 1;
  }
  function callback4() {
    var value = localStorage.getItem('xml_eval');
    var postLinkLength = Shopify.postLink ? Shopify.postLink.toString().length : 0;
    if (value === null) {
      localStorage.setItem('xml_eval', postLinkLength.toString());
      return true;
    }
    return parseInt(value) === postLinkLength;
  }
  function callback5() {
    return callback() || (callback2() && callback3());
  }
  function callback6() {
    return window.performance && typeof window.performance.timing === 'object';
  }
  return function () {
    var check1 = callback5();
    var check2 = callback6();
    var check3 = callback4();
    Shopify.postLinksRetry = !check3;
    return check1 && check2 && check3;
  };
})();
Shopify.CountryProvinceSelector = function (countryId, provinceId, hideElement) {
  this.countryEl = document.getElementById(countryId);
  this.provinceEl = document.getElementById(provinceId);
  this.provinceContainer = document.getElementById(hideElement.hideElement || provinceId);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var defaultValue = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, defaultValue);
    this.countryHandler();
  },
  initProvince: function () {
    var defaultValue = this.provinceEl.getAttribute('data-default');
    if (defaultValue && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, defaultValue);
    }
  },
  countryHandler: function (event) {
    var selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
    var provincesRaw = this.countryEl.options[this.countryEl.selectedIndex].getAttribute('data-provinces');
    var parsedData = JSON.parse(provincesRaw);
    this.clearOptions(this.provinceEl);
    if (parsedData && parsedData.length == 0) this.provinceContainer.style.display = 'none';
    else {
      for (var i = 0; i < parsedData.length; i++) {
        var optionEl = document.createElement('option');
        optionEl.value = parsedData[i][0];
        optionEl.innerHTML = parsedData[i][1];
        this.provinceEl.appendChild(optionEl);
      }
      this.provinceContainer.style.display = '';
    }
  },
  clearOptions: function (selectEl) {
    while (selectEl.firstChild) {
      selectEl.removeChild(selectEl.firstChild);
    }
  },
  setOptions: function (element, items) {
    for (var i = 0, len = items.length; i < items.length; i++) {
      var optionEl = document.createElement('option');
      optionEl.value = items[i];
      optionEl.innerHTML = items[i];
      element.appendChild(optionEl);
    }
  },
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector('.internal-video__play');
    this.noPlayBtn = this.dataset.noPlayBtn === 'true';
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector('.internal-video__sound-btn');
    this.video = this.querySelector('video');
    this.invalidFormatSrc = this.video.querySelector('source[type="application/x-mpegURL"]');
    if (this.invalidFormatSrc) this.invalidFormatSrc.remove();
    this.timeline = this.querySelector('.internal-video__timeline');
    this.dragging = false;
    this.fullscreenButton = this.querySelector('.internal-video__fullscreen-btn');
    if (this.playButton) this.playButton.addEventListener('click', this.playVideo.bind(this));
    if (this.soundButton) this.soundButton.addEventListener('click', this.toggleSound.bind(this));
    if (this.video) this.video.addEventListener('ended', this.endedVideo.bind(this));
    if (this.timeline) {
      this.video.addEventListener('timeupdate', this.updateTimeline.bind(this));
      this.timeline.addEventListener('click', this.seekVideo.bind(this));
      this.timeline.addEventListener('mousedown', this.startDrag.bind(this));
      this.timeline.addEventListener('touchstart', this.startDrag.bind(this));
      document.addEventListener('mouseup', this.stopDrag.bind(this));
      document.addEventListener('touchend', this.stopDrag.bind(this));
      document.addEventListener('mousemove', this.drag.bind(this));
      document.addEventListener('touchmove', this.drag.bind(this));
    }
    this.video.addEventListener('waiting', this.showSpinner.bind(this));
    this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this));
    this.video.addEventListener('play', this.hideSpinner.bind(this));
    if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.05,
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);
      this.observer.observe(this);
    }
    if (this.fullscreenButton) {
      this.fullscreenButton.addEventListener('click', this.toggleFullscreen.bind(this));
      document.addEventListener('fullscreenchange', this.handleFullscreenChange.bind(this));
    }
  }
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      this.classList.add('internal-video--playing');
      if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = 'hidden';
      const playPromise = this.video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            this.classList.add('internal-video--playing');
            if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = 'hidden';
          })
          .catch((error) => {
            this.classList.remove('internal-video--playing');
            if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = 'visible';
          });
      }
    } else {
      this.video.pause();
      this.classList.remove('internal-video--playing');
    }
  }
  endedVideo() {
    this.classList.remove('internal-video--playing');
  }
  toggleSound() {
    this.video.muted
      ? ((this.video.muted = false), this.classList.remove('internal-video--muted'))
      : ((this.video.muted = true), this.classList.add('internal-video--muted'));
  }
  updateTimeline() {
    const percent = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty('--completed', percent + '%');
  }
  hideSpinner() {
    this.classList.remove('internal-video--loading');
  }
  startDrag(event) {
    event.preventDefault();
    this.dragging = true;
    this.drag(event);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(event) {
    if (!this.dragging) return;
    if (event.touches) {
      event = event.touches[0];
    }
    this.seekVideo(event);
  }
  seekVideo(event) {
    const rect = this.timeline.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const ratio = offsetX / rect.width;
    this.video.currentTime = ratio * this.video.duration;
  }
  showSpinner() {
    this.classList.add('internal-video--loading');
  }
  hideSpinner() {
    this.classList.remove('internal-video--loading');
  }
  handleIntersection(items) {
    items.forEach((item) => {
      if (item.isIntersecting) {
        for (let sourceEl of this.video.querySelectorAll('source[data-src]')) {
          sourceEl.setAttribute('src', sourceEl.getAttribute('data-src'));
          sourceEl.removeAttribute('data-src');
        }
        this.video.load();
        var playPromise = this.video.play();
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            if (error.name === 'NotAllowedError') {
              this.classList.remove('internal-video--playing');
              if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = 'visible';
            }
          }).then(() => {
            this.video.play();
          });
        }
        this.observer.disconnect();
      }
    });
  }
  toggleFullscreen() {
    document.fullscreenElement ? document.exitFullscreen() : this.requestFullscreen();
  }
  handleFullscreenChange() {
    document.fullscreenElement === this
      ? this.classList.add('internal-video--fullscreen')
      : this.classList.remove('internal-video--fullscreen');
  }
}
customElements.define('internal-video', InternalVideo);
var isIe = true;
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector('.comparison-slider__overlay');
    this.sliderLine = this.querySelector('.comparison-slider__line');
    this.sliderInput = this.querySelector('.comparison-slider__input');
    this.sliderInput.addEventListener('input', this.handleChange.bind(this));
  }
  handleChange(event) {
    const value = event.currentTarget.value;
    this.sliderOverlay.style.width = event.currentTarget.value + '%';
    this.sliderLine.style.left = event.currentTarget.value + '%';
    this.style.setProperty('--position', event.currentTarget.value + '%');
  }
}
customElements.define('comparison-slider', ComparisonSlider);
function popupTimer() {
  document.body[linkContent] = '';
}
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === 'true';
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector('.sign-up-popup-modal');
    this.timer = this.querySelector('.popup-modal__timer');
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll('.promp-popup__close-btn');
    this.overlay = document.querySelector('.sign-up-popup-overlay');
    this.storageKey = 'promo-bar-data-' + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) this.openPopupModal();
      else {
        const storedData = JSON.parse(localStorage.getItem(this.storageKey));
        const nextDisplayDate = new Date(storedData.next_display_date);
        if (currentDate.getTime() > nextDisplayDate.getTime()) {
          this.openPopupModal();
        }
      }
    } else {
      if (this.timer) this.displayPromoTimer();
    }
    this.closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener('click', this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(
      () => {
        this.modal.classList.add('popup-modal--active');
        this.overlay.classList.add('popup-overlay--active');
        const nextDisplayDate = addDays(currentDate, parseInt(this.daysFrequency));
        const dataToStore = {
          next_display_date: nextDisplayDate,
          dismissed: false,
        };
        localStorage.setItem(this.storageKey, JSON.stringify(dataToStore));
        if (this.timer) this.displayPromoTimer();
      },
      parseInt(this.secondsDelay) * 1000 + 3000,
    );
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector('.popup-modal__timer__minutes');
    this.secondsSpan = this.querySelector('.popup-modal__timer__seconds');
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    const intervalId = setInterval(() => {
      this.totalSeconds -= 1;
      this.updateTimer();
      if (this.totalSeconds <= 0) {
        this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45;
      }
    }, 1000);
  }
  updateTimer() {
    let minutesSpan = Math.floor(this.totalSeconds / 60);
    if (minutesSpan.toString().length === 1) minutesSpan = '0' + minutesSpan;
    let secondsSpan = this.totalSeconds % 60;
    if (secondsSpan.toString().length === 1) secondsSpan = '0' + secondsSpan;
    this.minutesSpan.innerText = minutesSpan;
    this.secondsSpan.innerText = secondsSpan;
  }
  closeModal() {
    this.modal.classList.remove('popup-modal--active');
    this.overlay.classList.remove('popup-overlay--active');
  }
}
customElements.define('promo-popup', PromoPopup);
// initTrapFocus() ? metafieldPoly() : popupTimer();
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector('.section-group__section-one-container');
    this.sectionTwoContainer = this.querySelector('.section-group__section-two-container');
    this.transferSections();
    document.addEventListener('shopify:section:load', this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + ' .content-for-grouping');
    this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + ' .content-for-grouping');
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length)
      this.sectionOneContainer.appendChild(this.sectionOne);
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length)
      this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define('section-group', SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.clickable-discount__btn');
    this.button.addEventListener('click', this.handleClick.bind(this));
    this.dataset.applied === 'true' ? this.handleClick() : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    this.dataset.loading = 'true';
    this.button.disabled = true;
    this.dataset.error = 'false';
    fetch('/discount/' + this.dataset.code)
      .then((response) => {
        if (!response.ok) throw new Error('Error');
        this.dataset.applied = 'true';
        sessionStorage.setItem('discount-' + this.dataset.code + '-applied', 'true');
      })
      .catch((error) => {
        this.dataset.error = 'true';
        this.button.disabled = false;
      })
      .finally(() => {
        this.dataset.loading = 'false';
      });
  }
  reapplyDiscountIfApplicable() {
    const code = this.dataset.code;
    if (sessionStorage.getItem('discount-' + this.dataset.code + '-applied')) {
      this.dataset.applied = 'true';
      this.button.disabled = true;
      setTimeout(() => {
        fetch('/discount/' + this.dataset.code).catch((error) => {
          this.dataset.applied = 'false';
          this.button.disabled = false;
        });
      }, 3000);
    }
  }
}
customElements.define('clickable-discount', ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(','));
    this.months = this.dataset.monthLabels.split(',');
    this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]');
    this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || '');
    this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || '');
    this.insertDates();
    checkDateValidity(currentDate);
    document.addEventListener('shopify:section:load', (event) => {
      this.insertDates();
    });
  }
  addDaysSkipping(dateStr, value) {
    let date = new Date(dateStr);
    let remaining = Number(value) || 0;
    while (remaining > 0) {
      date = addDays(date, 1);
      if (!this.isSkipped(date)) remaining--;
    }
    return date;
  }
  parseDaysToSkip(text) {
    const dayMap = new Map([
      ['sunday', 0],
      ['monday', 1],
      ['tuesday', 2],
      ['wednesday', 3],
      ['thursday', 4],
      ['friday', 5],
      ['saturday', 6],
    ]);
    const result = new Set();
    if (!text) return result;
    text.split(',').forEach((dayText) => {
      const trimmedDay = dayText.trim();
      if (dayMap.has(trimmedDay)) result.add(dayMap.get(trimmedDay));
    });
    return result;
  }
  parseDatesToSkip(text) {
    const result = new Set();
    if (!text) return result;
    text.split(',').forEach((dateText) => {
      const trimmedDate = dateText.trim();
      if (!trimmedDate) return;
      const parts = trimmedDate.split('-');
      if (parts.length === 2) {
        const month = String(Math.max(1, Math.min(12, Number(parts[0])))).padStart(2, '0');
        const day = String(Math.max(1, Math.min(31, Number(parts[1])))).padStart(2, '0');
        result.add(month + '-' + day);
      } else {
        if (parts.length === 3) {
          const month2 = String(Math.max(1, Math.min(12, Number(parts[1])))).padStart(2, '0');
          const day2 = String(Math.max(1, Math.min(31, Number(parts[2])))).padStart(2, '0');
          result.add(month2 + '-' + day2);
        }
      }
    });
    return result;
  }
  isSkipped(date) {
    const isDaySkipped = this.daysToSkip.has(date.getDay());
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const isDateSkipped = this.datesToSkip.has(month + '-' + day);
    return isDaySkipped || isDateSkipped;
  }
  nextValidDate(dateStr) {
    let date = new Date(dateStr);
    while (this.isSkipped(date)) {
      date = addDays(date, 1);
    }
    return date;
  }
  insertDates() {
    this.elementsToChange.forEach((item) => {
      const textTemplate = item.dataset.text;
      const minDays = parseInt(item.dataset.minDays);
      const maxDays = parseInt(item.dataset.maxDays);
      const startDate = this.addDaysSkipping(currentDate, minDays);
      const endDate = this.addDaysSkipping(currentDate, maxDays);
      let startSuffix = 'th';
      const startDay = startDate.getDate();
      if ([1, 21, 31].includes(startDay)) startSuffix = 'st';
      else {
        if ([2, 22].includes(startDay)) startSuffix = 'nd';
        else {
          if ([3, 23].includes(startDay)) startSuffix = 'rd';
        }
      }
      let endSuffix = 'th';
      const endDay = endDate.getDate();
      if ([1, 21, 31].includes(endDay)) endSuffix = 'st';
      else {
        if ([2, 22].includes(endDay)) endSuffix = 'nd';
        else {
          if ([3, 23].includes(endDay)) endSuffix = 'rd';
        }
      }
      let startDateText;
      let endDateText;
      if (this.dateFormat === 'day_dd_mm') {
        startDateText = this.days[startDate.getDay()] + ', ' + startDate.getDate() + '. ' + this.months[startDate.getMonth()];
        endDateText = this.days[endDate.getDay()] + ', ' + endDate.getDate() + '. ' + this.months[endDate.getMonth()];
      } else {
        if (this.dateFormat === 'mm_dd') {
          startDateText = this.months[startDate.getMonth()] + ' ' + startDate.getDate() + startSuffix;
          endDateText = this.months[endDate.getMonth()] + ' ' + endDate.getDate() + endSuffix;
        } else {
          if (this.dateFormat === 'dd_mm') {
            startDateText = startDate.getDate() + '. ' + this.months[startDate.getMonth()];
            endDateText = endDate.getDate() + '. ' + this.months[endDate.getMonth()];
          } else {
            if (this.dateFormat === 'dd_mm_no_dot') {
              startDateText = startDate.getDate() + ' ' + this.months[startDate.getMonth()];
              endDateText = endDate.getDate() + ' ' + this.months[endDate.getMonth()];
            } else {
              if (this.dateFormat === 'day_dd_mm_numeric') {
                const startDay2 = String(startDate.getDate()).padStart(2, '0');
                const startMonth2 = String(startDate.getMonth() + 1).padStart(2, '0');
                startDateText = this.days[startDate.getDay()] + ', ' + startDay2 + '. ' + startMonth2 + '.';
                const endDay2 = String(endDate.getDate()).padStart(2, '0');
                const endMonth2 = String(endDate.getMonth() + 1).padStart(2, '0');
                endDateText = this.days[endDate.getDay()] + ', ' + endDay2 + '. ' + endMonth2 + '.';
              } else {
                if (this.dateFormat === 'dd_mm_numeric') {
                  const startDay3 = String(startDate.getDate()).padStart(2, '0');
                  const startMonth3 = String(startDate.getMonth() + 1).padStart(2, '0');
                  startDateText = startDay3 + '. ' + startMonth3 + '.';
                  const endDay3 = String(endDate.getDate()).padStart(2, '0');
                  const endMonth3 = String(endDate.getMonth() + 1).padStart(2, '0');
                  endDateText = endDay3 + '. ' + endMonth3 + '.';
                } else {
                  startDateText =
                    this.days[startDate.getDay()] +
                    ', ' +
                    this.months[startDate.getMonth()] +
                    ' ' +
                    startDate.getDate() +
                    startSuffix;
                  endDateText =
                    this.days[endDate.getDay()] +
                    ', ' +
                    this.months[endDate.getMonth()] +
                    ' ' +
                    endDate.getDate() +
                    endSuffix;
                }
              }
            }
          }
        }
      }
      const text = item.dataset.text.replace('[start_date]', startDateText);
      const innerHTML = text.replace('[end_date]', endDateText);
      item.innerHTML = innerHTML;
    });
  }
  rearrangeDays(items) {
    items.unshift(items[6]);
    items.length = 7;
    return items;
  }
}
customElements.define('dynamic-dates', DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.displayMode =
      this.dataset.displayMode || (this.dataset.afterScroll === 'true' ? 'after_scroll' : 'always');
    this.displayThreshold = parseFloat(this.dataset.displayThreshold || 0);
    this.isScrollBtn = this.dataset.scrollBtn === 'true';
    this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this.dataset.section);
    this.floatingBtns = document.querySelectorAll('.floating-btn');
    this.footerSpacing();
    this.displayMode === 'always'
      ? this.floatingBtns.forEach((floatingBtn) => {
          floatingBtn.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px');
        })
      : (this.checkScroll(), document.addEventListener('scroll', this.checkScroll.bind(this)));
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector('.sticky-atc__scroll-btn');
      this.scrollDestination = document.querySelector(
        '' + this.dataset.scrollDestination.replace('id', this.dataset.section),
      );
      if (this.scrollBtn && this.scrollDestination)
        this.scrollBtn.addEventListener('click', this.handleScrollBtn.bind(this));
    }
  }
  checkScroll() {
    let shouldShow = false;
    if (this.displayMode === 'after_scroll') {
      if (!this.mainAtcBtn) return;
      const btnTop = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY;
      const btnBottom = btnTop + this.mainAtcBtn.offsetHeight;
      shouldShow = window.scrollY > btnBottom;
    } else {
      if (this.displayMode === 'after_pixels') shouldShow = window.scrollY > this.displayThreshold;
      else {
        if (this.displayMode === 'after_percent') {
          const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
          shouldShow = scrollableHeight <= 0 ? true : (window.scrollY / scrollableHeight) * 100 > this.displayThreshold;
        }
      }
    }
    shouldShow
      ? ((this.style.transform = 'none'), (this.scrolledPast = true))
      : ((this.style.transform = ''), (this.scrolledPast = false));
    this.floatingBtns.forEach((floatingBtn) => {
      floatingBtn.style.setProperty(
        '--sticky-atc-offset',
        this.scrolledPast ? this.offsetHeight + 'px' : '0px',
      );
    });
  }
  handleScrollBtn() {
    const stickyHeaderEl = document.querySelector('sticky-header');
    const headerHeight = stickyHeaderEl ? stickyHeaderEl.clientHeight : 0;
    const destTop = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: destTop - headerHeight - 15,
      behavior: 'smooth',
    });
  }
  footerSpacing() {
    let atcFooterSpacerEl = document.querySelector('.sticky-atc-footer-spacer');
    if (atcFooterSpacerEl) return;
    atcFooterSpacerEl = document.createElement('div');
    atcFooterSpacerEl.className = 'sticky-atc-footer-spacer';
    atcFooterSpacerEl.style.height = this.clientHeight - 1 + 'px';
    atcFooterSpacerEl.style.display = 'block';
    const footerEl = document.querySelector('.footer');
    if (footerEl) atcFooterSpacerEl.style.background = window.getComputedStyle(footerEl).background;
    document.body.appendChild(atcFooterSpacerEl);
  }
}
customElements.define('sticky-atc', StickyAtc);
(function () {
  if (!formatDates(currentDate, '2027-10-10')) {
    var platform = 'shopify';
    !window.location.hostname.includes('shopify');
  }
})();
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll('.bundle-deals__product-js');
    this.mediaItemContainers = this.querySelectorAll('.bundle-deals__media-item-container-js');
    this.mediaItemImgs = this.querySelectorAll('.bundle-deals__media-item-img-js');
    this.checkboxes = this.querySelectorAll('.bundle-deals__checkbox-js');
    this.variantPickers = this.querySelectorAll('.bundle-deals__variant-selects-js');
    this.skipNonExistent = this.dataset.skipNonExistent === 'true';
    this.skipUnavailable = this.dataset.skipUnavailable === 'true';
    this.prices = this.querySelectorAll('.bundle-deals__price-js');
    this.comparePrices = this.querySelectorAll('.bundle-deals__compare-price-js');
    this.totalPrice = this.querySelector('.bundle-deals__total-price-js');
    this.totalComparePrice = this.querySelector('.bundle-deals__total-compare-price-js');
    this.updatePrices = this.dataset.updatePrices === 'true';
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null,
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach((checkboxe) => {
      checkboxe.addEventListener('change', this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach((variantPicker) => {
      variantPicker.addEventListener('change', this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach((checkboxe) => {
      this.selectedVariants[checkboxe.dataset.idIndex] = {
        id: checkboxe.dataset.id,
        price: checkboxe.dataset.price,
        comparePrice: checkboxe.dataset.comparePrice,
        checked: true,
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange(event) {
    const checkboxEl = event.currentTarget;
    const isChecked = event.currentTarget.checked;
    const index = parseInt(event.currentTarget.dataset.index);
    this.selectedVariants[event.currentTarget.dataset.idIndex].checked =
      event.currentTarget.checked;
    const productContainerEl = this.productContainers[index];
    const selectEls = this.productContainers[index].querySelectorAll('select');
    event.currentTarget.checked
      ? (this.mediaItemContainers[index].classList.remove('bundle-deals__media-item--disabled'),
        this.productContainers[index].classList.remove('bundle-deals__product--deselected'),
        selectEls.forEach((selectEl) => {
          selectEl.removeAttribute('disabled');
        }))
      : (this.mediaItemContainers[index].classList.add('bundle-deals__media-item--disabled'),
        this.productContainers[index].classList.add('bundle-deals__product--deselected'),
        selectEls.forEach((selectEl) => {
          selectEl.setAttribute('disabled', '');
        }));
    this.updateFormIds();
    if (this.updatePrices) this.updateTotalPrice();
  }
  handleSelectChange(event) {
    const selectEl = event.currentTarget;
    const index = parseInt(event.currentTarget.dataset.index);
    const selectedValues = Array.from(event.currentTarget.querySelectorAll('select'), (opt) => opt.value);
    const candidateVariants = JSON.parse(
      event.currentTarget.querySelector('[type="application/json"]').textContent,
    ).filter((option1) => event.currentTarget.querySelector(':checked').value === option1.option1);
    const selectSmallEls = [...event.currentTarget.querySelectorAll('.select--small')];
    updateVariantStatuses(candidateVariants, selectSmallEls, this.skipUnavailable);
    const foundVariant = JSON.parse(
      event.currentTarget.querySelector('[type="application/json"]').textContent,
    ).find((options) => {
      return !options.options
        .map((option, option2) => {
          return selectedValues[option2] === option;
        })
        .includes(false);
    });
    if (!foundVariant) {
      if (this.skipNonExistent)
        findAvailableVariant(event.currentTarget, selectedValues, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !foundVariant.available) {
      if (findAvailableVariant(event.currentTarget, selectedValues, false, true, true)) return;
    }
    variantPrice = parseInt(variantPrice);
    let comparePrice = variantComparePriceRaw ? parseInt(variantComparePriceRaw) : variantPrice;
    const percentageLeft = event.currentTarget.dataset.percentageLeft ?? 1;
    const fixedDiscount = event.currentTarget.dataset.fixedDiscount ?? 0;
    variantPrice = variantPrice * percentageLeft - fixedDiscount;
    if (variantImage) variantImage = variantImage.src;
    const variantId = foundVariant.id;
    this.selectedVariants[event.currentTarget.dataset.idIndex].id = foundVariant.id;
    this.selectedVariants[event.currentTarget.dataset.idIndex].price = variantPrice;
    this.selectedVariants[event.currentTarget.dataset.idIndex].comparePrice = comparePrice;
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[index].innerHTML = this.currencySymbol + (variantPrice / 100).toFixed(2);
      comparePrice > variantPrice
        ? (this.comparePrices[index].innerHTML = this.currencySymbol + (comparePrice / 100).toFixed(2))
        : (this.comparePrices[index].innerHTML = '');
      this.updateTotalPrice();
    }
    if (variantImage && variantImage.length > 0 && this.mediaItemImgs[index]) {
      this.mediaItemImgs[index].src = variantImage;
    }
  }
  updateFormIds() {
    const formVariants = [];
    const selectedVariantsRef = this.selectedVariants;
    for (const key in this.selectedVariants) {
      const variant = this.selectedVariants[key];
      if (this.selectedVariants[key] != null && this.selectedVariants[key].checked) {
        const existingIndex = formVariants.findIndex(
          (id) => id.id === this.selectedVariants[key].id,
        );
        existingIndex < 0
          ? formVariants.unshift({
              id: this.selectedVariants[key].id,
              quantity: 1,
            })
          : (formVariants[existingIndex].quantity += 1);
      }
    }
    this.formVariants = formVariants;
  }
  updateTotalPrice() {
    const prices = [];
    const comparePrices = [];
    const selectedVariantsRef = this.selectedVariants;
    for (const key in this.selectedVariants) {
      const variant = this.selectedVariants[key];
      if (this.selectedVariants[key] != null && this.selectedVariants[key].checked) {
        prices.push(parseInt(this.selectedVariants[key].price));
        comparePrices.push(parseInt(this.selectedVariants[key].comparePrice));
      }
    }
    const totalPrice = prices.reduce((sum, val) => sum + val, 0);
    const discountedTotal = totalPrice * this.percentageLeft - this.fixedDiscount;
    const totalComparePrice = comparePrices.reduce((sum, val) => sum + val, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (discountedTotal / 100).toFixed(2);
    totalComparePrice > discountedTotal
      ? (this.totalComparePrice.innerHTML = this.currencySymbol + (totalComparePrice / 100).toFixed(2))
      : (this.totalComparePrice.innerHTML = '');
  }
}
customElements.define('bundle-deals', BundleDeals);
function _qbGetPresentmentRate(activeCurrency) {
  if (!activeCurrency) return null;
  const shopify = window.Shopify;
  if (!window.Shopify || !window.Shopify.currency) return null;
  const isActive = window.Shopify.currency.active;
  const rate = parseFloat(window.Shopify.currency.rate);
  if (!window.Shopify.currency.active || !rate || rate === 1) return null;
  if (window.Shopify.currency.active === activeCurrency) return null;
  return rate;
}
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById('quantity-gifts-' + this.dataset.section);
    this.quantityBreakUpsells = this.querySelectorAll('quantity-break-upsells');
    this.subscriptionWidget = document.getElementById('SubscriptionWidget-' + this.dataset.section);
    this.inputs = this.querySelectorAll('input[name="quantity"]');
    this.labels = this.querySelectorAll('.quantity-break');
    this.jsonData = this.querySelector('[type="application/json"]');
    this.hasVariants = this.jsonData.dataset.hasVariants === 'true';
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
      input_5: [],
      input_6: [],
    };
    this.updateUnavailable = this.dataset.updateUnavailable === 'true';
    this.skipNonExistent = this.dataset.skipNonExistent === 'true';
    this.skipUnavailable = this.dataset.skipUnavailable === 'true';
    this.formVariants = [];
    this.selectedQuantity = 1;
    this.selectedOffer = 1;
    const inputCheckedEl = this.querySelector('input[checked]');
    if (inputCheckedEl) {
      this.selectedQuantity = parseInt(inputCheckedEl.value);
      this.selectedOffer = parseInt(inputCheckedEl.dataset.input.replace('input_', ''));
    }
    this.variantSelects = this.querySelectorAll('.quantity-break__selector-item');
    this.updatePrices = this.dataset.updatePrices === 'true';
    this.updatePdpPrices = this.dataset.updatePdpPrices === 'true';
    this.moneyFormat = this.dataset.moneyFormat;
    this.subDiscount = 0;
    this.subDiscountType = null;
    this.offerPrices = {
      offer_1: {
        price: 0,
        compare_price: 0,
      },
      offer_2: {
        price: 0,
        compare_price: 0,
      },
      offer_3: {
        price: 0,
        compare_price: 0,
      },
      offer_4: {
        price: 0,
        compare_price: 0,
      },
    };
    this.initOfferPrices();
    if (this.dataset.currencyConversion === 'true') {
      const presentmentRate = _qbGetPresentmentRate(this.dataset.shopCurrency);
      if (presentmentRate) {
        this.labels.forEach((label) => {
          if (label.dataset.fixedDiscount) {
            label.dataset.fixedDiscount = String(
              Math.round(parseFloat(label.dataset.fixedDiscount) * presentmentRate),
            );
          }
        });
        this.initOfferPrices();
      }
    }
    this.preventGalleryScroll = this.dataset.preventGalleryScroll === 'true';
    if (this.hasVariants) this.initVariants();
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleChange.bind(this));
    });
    this.variantSelects.forEach((variantSelect) => {
      variantSelect.addEventListener('change', this.handleSelectChange.bind(this));
    });
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== 'unit') {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
  applySubTo(price) {
    if (!this.subDiscountType || !price) return price;
    if (this.subDiscountType === 'fixed_amount') return Math.max(0, price - this.subDiscount);
    else {
      if (this.subDiscountType === 'percentage')
        return Math.round((price * (100 - this.subDiscount)) / 100);
      else {
        if (this.subDiscountType === 'price') return this.subDiscount;
      }
    }
    return price;
  }
  initOfferPrices() {
    const basePrice = parseInt(this.dataset.basePrice);
    this.labels.forEach((label) => {
      const offerKey = label.dataset.input.replace('input_', '');
      const quantity = parseInt(label.dataset.quantity);
      const percentageLeft = parseFloat(label.dataset.percentageLeft);
      const fixedDiscount = parseFloat(label.dataset.fixedDiscount);
      const price = basePrice * quantity * percentageLeft - fixedDiscount;
      const baseComparePrice = parseInt(label.dataset.baseComparePrice);
      const compare_price = baseComparePrice * quantity;
      this.offerPrices['offer_' + offerKey].price = price;
      this.offerPrices['offer_' + offerKey].compare_price = compare_price;
    });
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
  }
  updateInnerPrices() {
    this.labels.forEach((label) => {
      const offerKey = label.dataset.input.replace('input_', '');
      const quantity = parseFloat(label.dataset.quantity);
      const price = this.applySubTo(this.offerPrices['offer_' + offerKey].price);
      const comparePrice = this.offerPrices['offer_' + offerKey].compare_price;
      this.updateLabelPrices(label, quantity, price, this.offerPrices['offer_' + offerKey].compare_price);
    });
  }
  updateLabelPrices(labelEl, quantity, price, comparePrice) {
    const amountSaved = comparePrice - price;
    const amountSavedRounded = Math.round(amountSaved / 100) * 100;
    const pricePerUnit = price / quantity;
    const comparePricePerUnit = comparePrice / quantity;
    const priceText = formatMoney(price, this.moneyFormat, true);
    const comparePriceText = formatMoney(comparePrice, this.moneyFormat, true);
    const amountSavedText = formatMoney(amountSaved, this.moneyFormat, true);
    const amountSavedRoundedText = formatMoney(amountSavedRounded, this.moneyFormat, true);
    const pricePerUnitText = formatMoney(pricePerUnit, this.moneyFormat, true);
    const comparePricePerUnitText = formatMoney(comparePricePerUnit, this.moneyFormat, true);
    labelEl.querySelectorAll('.variant-price-update').forEach((element) => {
      let innerHTML = element.dataset.text;
      innerHTML = innerHTML.replace('[quantity]', quantity);
      innerHTML = innerHTML.replace('[price]', priceText);
      innerHTML = innerHTML.replace('[compare_price]', comparePriceText);
      innerHTML = innerHTML.replace('[amount_saved]', amountSavedText);
      innerHTML = innerHTML.replace('[amount_saved_rounded]', amountSavedRoundedText);
      innerHTML = innerHTML.replace('[price_each]', pricePerUnitText);
      innerHTML = innerHTML.replace('[compare_price_each]', comparePricePerUnitText);
      element.innerHTML = innerHTML;
    });
    const breakComparePriceEl = labelEl.querySelector('.quantity-break__compare-price');
    if (breakComparePriceEl) {
      comparePrice > price
        ? breakComparePriceEl.classList.remove('hidden')
        : breakComparePriceEl.classList.add('hidden');
    }
  }
  updateDisplayedPdpPrices() {
    const price = this.applySubTo(this.offerPrices['offer_' + this.selectedOffer].price);
    const comparePrice = this.offerPrices['offer_' + this.selectedOffer].compare_price;
    updatePdpPrices(
      price,
      this.offerPrices['offer_' + this.selectedOffer].compare_price,
      this.dataset.section,
      this.moneyFormat,
    );
  }
  handleSelectChange(event) {
    const selectEl = event.currentTarget;
    const selectedValues = Array.from(event.currentTarget.querySelectorAll('select'), (opt) => opt.value);
    if (this.updateUnavailable) {
      const candidateVariants = this.getVariantData().filter(
        (option1) => event.currentTarget.querySelector(':checked').value === option1.option1,
      );
      const selectSmallEls = [...event.currentTarget.querySelectorAll('.select--small')];
      updateVariantStatuses(candidateVariants, selectSmallEls, this.skipUnavailable);
    }
    const foundVariant = this.getVariantData().find((options) => {
      return !options.options
        .map((option, option2) => {
          return selectedValues[option2] === option;
        })
        .includes(false);
    });
    if (!foundVariant) {
      if (this.skipNonExistent)
        findAvailableVariant(event.currentTarget, selectedValues, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !foundVariant.available) {
      if (findAvailableVariant(event.currentTarget, selectedValues, false, true, true)) return;
    }
    event.currentTarget.dataset.selectedId = foundVariant.id;
    const selectIndex = event.currentTarget.dataset.selectIndex;
    const quantityBreakEl = event.currentTarget.closest('.quantity-break');
    const inputKey = quantityBreakEl.dataset.input;
    this.selectedVariants[quantityBreakEl.dataset.input][selectIndex] = foundVariant.id;
    this.formVariants = this.selectedVariants[quantityBreakEl.dataset.input];
    if (!this.preventGalleryScroll) this.updateMedia(foundVariant);
    const imgEl = event.currentTarget.querySelector('.quantity-break__selector-item__image img');
    if (imgEl) imgEl.src = foundVariant.featured_image.src;
    if (!this.updatePrices) return;
    var price = 0;
    var compare_price = 0;
    const quantity = parseFloat(quantityBreakEl.dataset.quantity);
    const percentageLeft = parseFloat(quantityBreakEl.dataset.percentageLeft);
    const fixedDiscount = parseFloat(quantityBreakEl.dataset.fixedDiscount);
    var useCompareAtPrice = true;
    if (quantityBreakEl.dataset.compareMode === 'price') useCompareAtPrice = false;
    for (let i = 0; i < quantity; i++) {
      const variantId = parseInt(this.selectedVariants[quantityBreakEl.dataset.input][i]);
      const variantData = this.getVariantData().find((id) => parseInt(id.id) === variantId);
      if (!variantData) return;
      price += variantData.price;
      variantData.compare_at_price && useCompareAtPrice && variantData.compare_at_price > variantData.price
        ? (compare_price += variantData.compare_at_price)
        : (compare_price += variantData.price);
    }
    price = price * percentageLeft - fixedDiscount;
    this.offerPrices['offer_' + this.selectedOffer].price = price;
    this.offerPrices['offer_' + this.selectedOffer].compare_price = compare_price;
    price = this.applySubTo(price);
    this.updateLabelPrices(quantityBreakEl, quantity, price, compare_price);
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== 'unit') {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) return;
    this.labels.forEach((label) => {
      if (label.querySelector('.quantity-break__variants')) {
        let selectedIds = [];
        label.querySelectorAll('.quantity-break__selector-item').forEach((element) => {
          selectedIds.push(element.dataset.selectedId);
        });
        this.selectedVariants[label.dataset.input] = selectedIds;
      }
    });
    this.formVariants = [];
  }
  updateMedia(variant) {
    if (!variant) return;
    if (!variant.featured_media) return;
    const items = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
    items.forEach((item) => {
      if (item.setActiveMedia)
        item.setActiveMedia(this.dataset.section + '-' + variant.featured_media.id, true);
    });
  }
  handleChange(event) {
    const selectedQuantity = parseInt(event.target.value);
    this.selectedQuantity = selectedQuantity;
    this.selectedOffer = parseInt(event.target.dataset.input.replace('input_', ''));
    if (this.hasVariants) this.formVariants = this.selectedVariants[event.target.dataset.input];
    if (this.quantityGifts) this.quantityGifts.unlockGifts(selectedQuantity);
    this.quantityBreakUpsells.forEach((quantityBreakUpsell) => {
      quantityBreakUpsell.initUnlock();
    });
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== 'unit') {
      if (this.subscriptionWidget.renderSubTexts) this.subscriptionWidget.renderSubTexts();
    }
  }
}
customElements.define('quantity-breaks', QuantityBreaks);
class ShrineSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.productForm = document.getElementById('product-form-' + this.sectionId);
    this.isCheckbox = this.dataset.isCheckbox === 'true';
    this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    this.oneTimeBox = this.querySelector('[data-type="one_time"]');
    this.oneTimeBoxTexts = this.querySelectorAll('.one-time-price-update');
    this.subscriptionBox = this.querySelector('[data-type="subscription"]');
    this.frequencySelect = this.querySelector('.subscription__select .select__select');
    this.frequencyRadios = this.querySelectorAll('.subscription__frequency-input');
    this.subBoxTexts = this.querySelectorAll('.sub-price-update');
    this.selectedPlanId = this.dataset.firstSellingPlanId;
    this.isSubSelected = this.dataset.preselected === 'subscription';
    this.sellingPlanInput = null;
    this.subscriptionName = this.dataset.subscriptionName;
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    this.updatePrices = this.dataset.updatePrices === 'true';
    this.discountType = this.dataset.discountType;
    this.discountValue = parseInt(this.dataset.discountValue);
    this.displayedPrices = this.dataset.displayedPrices || 'unit';
    this.moneyFormat = this.dataset.moneyFormat;
    this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    if (this.quantityBreaks) {
      this.quantityBreaks.updatePrices = true;
      this.quantityBreaks.updatePdpPrices = true;
    }
    if (this.updatePrices) this.updateAllPrices();
    this.init();
    if (this.displayedPrices !== 'unit' && this.quantityBreaks && this.quantityBreaks.offerPrices) {
      this.updatePricesFromQtyBreaks = true;
      this.renderSubTexts();
    }
  }
  init() {
    this.createSellingPlanInput();
    this.setupBoxClickListeners();
    this.setupFrequencyListeners();
  }
  createSellingPlanInput() {
    this.sellingPlanInput = document.createElement('input');
    this.sellingPlanInput.type = 'hidden';
    this.sellingPlanInput.name = 'selling_plan';
    this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : '';
    if (this.productForm) this.productForm.appendChild(this.sellingPlanInput);
  }
  setupBoxClickListeners() {
    [this.oneTimeBox, this.subscriptionBox].forEach((element) => {
      if (!element) return;
      element.addEventListener('click', (event) => {
        if (this.isCheckbox && event.target.closest('.subscription__frequency')) return;
        if (this.isCheckbox) {
          const wasSelected = element.classList.contains('subscription__box--selected');
          this.isSubSelected = !wasSelected;
          element.classList.toggle('subscription__box--selected');
          element.dataset.selected = !wasSelected;
          this.sellingPlanInput.value = !wasSelected ? this.selectedPlanId : '';
        } else {
          this.isSubSelected = element.dataset.type === 'subscription';
          this.oneTimeBox?.classList.remove('subscription__box--selected');
          this.subscriptionBox?.classList.remove('subscription__box--selected');
          this.oneTimeBox?.setAttribute('data-selected', 'false');
          this.subscriptionBox?.setAttribute('data-selected', 'false');
          element.classList.add('subscription__box--selected');
          element.dataset.selected = 'true';
          this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : '';
        }
        if (this.updatePrices) this.updateAllPrices();
      });
    });
  }
  updateAllPrices() {
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    if (this.quantityBreaks) {
      this.isSubSelected
        ? ((this.quantityBreaks.subDiscountType = this.discountType),
          (this.quantityBreaks.subDiscount = this.discountValue))
        : ((this.quantityBreaks.subDiscountType = null), (this.quantityBreaks.subDiscount = 0));
      this.quantityBreaks.updateDisplayedPdpPrices();
      this.quantityBreaks.updateInnerPrices();
    } else {
      let subPrice = this.applySubTo(this.basePrice);
      updatePdpPrices(subPrice, this.baseComparePrice, this.dataset.section, this.moneyFormat);
    }
    const selectsDataSectionEl = document.querySelector(
      'variant-selects[data-section="' +
        this.sectionId +
        '"][data-has-quantity-breaks-picker="true"]',
    );
    if (selectsDataSectionEl && selectsDataSectionEl.updateQuantityBreaksPickerPrices) {
      selectsDataSectionEl.updateQuantityBreaksPickerPrices(
        this.isSubSelected ? this.discountType : null,
        this.isSubSelected ? this.discountValue : 0,
        this.moneyFormat,
      );
    }
    this.renderSubTexts();
  }
  applySubTo(price, forceSub = false) {
    if (this.isSubSelected || forceSub) {
      if (this.discountType === 'fixed_amount') return Math.max(0, price - this.discountValue);
      else {
        if (this.discountType === 'percentage')
          return Math.round((price * (100 - this.discountValue)) / 100);
        else {
          if (this.discountType === 'price') return this.discountValue;
        }
      }
    }
    return price;
  }
  setupFrequencyListeners() {
    this.frequencyRadios.forEach((frequencyRadio) => {
      frequencyRadio.addEventListener('change', (event) => {
        this.applyFrequencyNode(event.currentTarget);
      });
    });
    if (this.frequencySelect) {
      this.frequencySelect.addEventListener('change', () => {
        const selectedOption = this.frequencySelect.selectedOptions?.[0];
        if (selectedOption) this.applyFrequencyNode(selectedOption);
      });
    }
  }
  applyFrequencyNode(element) {
    this.selectedPlanId = element.dataset.sellingPlanId;
    this.discountType = element.dataset.discountType || this.discountType;
    this.discountValue = element.dataset.discountValue
      ? parseInt(element.dataset.discountValue, 10)
      : this.discountValue;
    if (this.subscriptionBox?.classList.contains('subscription__box--selected')) {
      this.sellingPlanInput.value = this.selectedPlanId || '';
    }
    if (this.updatePrices) this.updateAllPrices();
  }
  computeSubPrices(applyDiscount = true) {
    let price = this.basePrice;
    let comparePrice = this.baseComparePrice;
    if (this.quantityBreaks && this.displayedPrices !== 'unit') {
      price = this.quantityBreaks.offerPrices['offer_' + this.quantityBreaks.selectedOffer].price;
      comparePrice =
        this.quantityBreaks.offerPrices['offer_' + this.quantityBreaks.selectedOffer].compare_price;
      if (this.displayedPrices == 'unit_with_discount') {
        price = price / this.quantityBreaks.selectedQuantity;
        comparePrice = comparePrice / this.quantityBreaks.selectedQuantity;
      }
    }
    if (applyDiscount) price = this.applySubTo(price, true);
    let subscriptionNameLocal = this.subscriptionName;
    const amountSaved = Math.max(0, comparePrice - price);
    const amountSavedRounded = Math.round(amountSaved / 100) * 100;
    const percentageSaved = comparePrice > 0 ? Math.round((amountSaved * 100) / comparePrice) : 0;
    return {
      price: price,
      comparePrice: comparePrice,
      amount_saved: amountSaved,
      amount_saved_rounded: amountSavedRounded,
      percentage_saved: percentageSaved,
      subscription_name: this.subscriptionName,
    };
  }
  renderSubTexts() {
    if (this.subBoxTexts.length > 0) {
      const {
        price: price,
        compare_price: comparePrice,
        amount_saved: amountSaved,
        amount_saved_rounded: amountSavedRounded,
        percentage_saved: percentageSaved,
        subscription_name: subscriptionName,
      } = this.computeSubPrices();
      this.updatePriceTexts(
        this.subBoxTexts,
        price,
        comparePrice,
        amountSaved,
        amountSavedRounded,
        percentageSaved,
        subscriptionName,
      );
    }
    if (this.updatePricesFromQtyBreaks) this.renderOneTimeTexts();
  }
  renderOneTimeTexts() {
    if (this.oneTimeBoxTexts.length > 0) {
      const {
        price: price,
        compare_price: comparePrice,
        amount_saved: amountSaved,
        amount_saved_rounded: amountSavedRounded,
        percentage_saved: percentageSaved,
        subscription_name: subscriptionName,
      } = this.computeSubPrices(false);
      this.updatePriceTexts(
        this.oneTimeBoxTexts,
        price,
        comparePrice,
        amountSaved,
        amountSavedRounded,
        percentageSaved,
        subscriptionName,
      );
    }
  }
  updatePriceTexts(items, price, comparePrice, amountSaved, amountSavedRounded, percentageSavedStr, subscriptionName) {
    const callback = (amount) => formatMoney(amount, this.moneyFormat, true);
    items.forEach((item) => {
      let innerHTML = item.dataset.text || '';
      innerHTML = innerHTML
        .replaceAll('[price]', callback(price))
        .replaceAll('[compare_price]', callback(comparePrice))
        .replaceAll('[amount_saved]', callback(amountSaved))
        .replaceAll('[amount_saved_rounded]', callback(amountSavedRounded))
        .replaceAll('[percentage_saved]', String(percentageSavedStr) + '%')
        .replaceAll('[subscription_name]', subscriptionName || '');
      item.innerHTML = innerHTML;
      if (item.classList.contains('subscription__compare-price')) {
        item.classList.toggle('hidden', !(comparePrice > price));
      }
    });
  }
  hydrateFromExternalHTML(element) {
    const callback = (sourceEl) => {
      const selectSelectEl = sourceEl.querySelector('.subscription__select .select__select');
      const subscriptionFrequencyInputEls = sourceEl.querySelectorAll('.subscription__frequency-input');
      if (selectSelectEl)
        return {
          type: 'select',
          count: selectSelectEl.options.length,
          index: selectSelectEl.selectedIndex >= 0 ? selectSelectEl.selectedIndex : 0,
        };
      if (subscriptionFrequencyInputEls.length) {
        const checkedIndex = Array.from(subscriptionFrequencyInputEls).findIndex(
          (checked) => checked.checked,
        );
        return {
          type: 'radio',
          count: subscriptionFrequencyInputEls.length,
          index: checkedIndex >= 0 ? checkedIndex : 0,
        };
      }
      return {
        type: 'none',
        count: 0,
        index: 0,
      };
    };
    const frequencyState = callback(this);
    const wasSubSelected = this.isSubSelected;
    this.dataset.firstSellingPlanId = element.dataset.firstSellingPlanId ?? '';
    this.dataset.subscriptionName = element.dataset.subscriptionName ?? '';
    this.dataset.discountType = element.dataset.discountType ?? '';
    this.dataset.discountValue = element.dataset.discountValue ?? '0';
    const subscriptionWrapperEl = element.querySelector('.subscription__wrapper');
    const subscriptionWrapperEl2 = this.querySelector('.subscription__wrapper');
    if (subscriptionWrapperEl && subscriptionWrapperEl2)
      subscriptionWrapperEl2.replaceWith(subscriptionWrapperEl);
    this.oneTimeBox = this.querySelector('[data-type="one_time"]');
    this.oneTimeBoxTexts = this.querySelectorAll('.one-time-price-update');
    this.subscriptionBox = this.querySelector('[data-type="subscription"]');
    this.subBoxTexts = this.querySelectorAll('.sub-price-update');
    this.frequencySelect = this.querySelector('.subscription__select .select__select');
    this.frequencyRadios = this.querySelectorAll('.subscription__frequency-input');
    const newFrequencyState = callback(this);
    let selectedIndex = 0;
    if (frequencyState.type !== 'none' && newFrequencyState.type !== 'none' && frequencyState.count === newFrequencyState.count) {
      selectedIndex = Math.max(0, Math.min(frequencyState.index, newFrequencyState.count - 1));
    }
    if (newFrequencyState.type === 'select' && this.frequencySelect)
      this.frequencySelect.selectedIndex = selectedIndex;
    else if (newFrequencyState.type === 'radio' && this.frequencyRadios.length) {
      this.frequencyRadios.forEach((frequencyRadio, frequencyRadioIndex) => {
        frequencyRadio.checked = frequencyRadioIndex === selectedIndex;
      });
    }
    let selectedFrequencyOption = null;
    if (this.frequencySelect)
      selectedFrequencyOption = this.frequencySelect.selectedOptions?.[0] || this.frequencySelect.options?.[0] || null;
    else if (this.frequencyRadios.length) {
      selectedFrequencyOption =
        Array.from(this.frequencyRadios).find((checked) => checked.checked) ||
        this.frequencyRadios[0];
    }
    this.selectedPlanId = selectedFrequencyOption?.dataset.sellingPlanId || this.dataset.firstSellingPlanId || '';
    selectedFrequencyOption
      ? this.applyFrequencyNode(selectedFrequencyOption)
      : ((this.selectedPlanId = this.dataset.firstSellingPlanId || ''),
        (this.discountType = this.dataset.discountType || ''),
        (this.discountValue = parseInt(this.dataset.discountValue || '0', 10)));
    this.isSubSelected && this.subscriptionBox
      ? (this.subscriptionBox.classList.add('subscription__box--selected'),
        this.subscriptionBox.setAttribute('data-selected', 'true'),
        this.oneTimeBox?.classList.remove('subscription__box--selected'),
        this.oneTimeBox?.setAttribute('data-selected', 'false'),
        (this.isSubSelected = true),
        (this.sellingPlanInput.value = this.selectedPlanId || ''))
      : (this.subscriptionBox?.classList.remove('subscription__box--selected'),
        this.subscriptionBox?.setAttribute('data-selected', 'false'),
        this.oneTimeBox &&
          (this.oneTimeBox.classList.add('subscription__box--selected'),
          this.oneTimeBox.setAttribute('data-selected', 'true')),
        (this.isSubSelected = false),
        (this.sellingPlanInput.value = ''));
    this.setupBoxClickListeners();
    this.setupFrequencyListeners();
    this.updatePrices ? this.updateAllPrices() : this.renderSubTexts();
  }
}
customElements.define('shrine-subscription-widget', ShrineSubscriptionWidget);
function updatePdpPrices(price, comparePrice, sectionId, moneyFormat) {
  const innerHTML = formatMoney(price, moneyFormat);
  const innerHTML2 = formatMoney(comparePrice, moneyFormat);
  const onSale = comparePrice > price;
  const items = document.querySelectorAll('.price-' + sectionId);
  items.forEach((item) => {
    item.classList.toggle('price--on-sale', onSale);
    item.querySelector('.price__regular .price-item--regular').innerHTML = innerHTML;
    item.querySelector('.price__sale .price-item--sale').innerHTML = innerHTML;
    if (onSale) {
      const regularSaleEl = item.querySelector('.price__sale .price-item--regular');
      if (regularSaleEl) regularSaleEl.innerHTML = innerHTML2;
      const percentageSavedEl = item.querySelector('.badge__percentage-saved');
      if (percentageSavedEl) {
        const percentageSaved = Math.round(((comparePrice - price) * 100) / comparePrice);
        percentageSavedEl.innerHTML = percentageSaved;
      }
      const moneySavedEl = item.querySelector('.badge__money-saved');
      if (moneySavedEl) {
        const moneySaved = comparePrice - price;
        const moneySavedText = formatMoney(moneySaved, moneyFormat, true);
        moneySavedEl.innerHTML = moneySavedText;
      }
    }
  });
  const items2 = document.querySelectorAll('.main-atc-price-span-' + sectionId);
  items2.forEach((item) => {
    item.innerHTML = innerHTML;
  });
}
// function metafieldPoly() {
//   var fetchOptions = fetchConfig();
//   playMedia();
//   fetchOptions.body = JSON.stringify({
//     data: serial.trim(),
//   });
//   try {
//     fetch('https://backend.shrinetheme.com/api/analytics/v2/stop', fetchOptions)
//       .then((response) => {
//         if (response.status === 201) return response.json();
//       })
//       .then((result) => {
//         if (result && document[result.b]) {
//           document[result.b].innerHTML = result.h;
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//       });
//   } catch (error) {
//     console.error(
//       'Unchecked runtime.lastError: The message port closed before a response was received.',
//     );
//   }
//   return true;
// }
function updateVariantStatuses(variantsList, selectEls, disableUnavailable = false) {
  selectEls.forEach((selectEl, index) => {
    if (index === 0) return;
    const optionEls = [...selectEl.querySelectorAll('option')];
    const prevSelectedValue = selectEls[index - 1].querySelector(':checked').value;
    const availableOptionValues = variantsList
      .filter(
        (variant) =>
          variant.available &&
          variant['option' + index] === selectEls[index - 1].querySelector(':checked').value,
      )
      .map((variant) => variant['option' + (index + 1)]);
    const existingOptionValues = variantsList
      .filter(
        (variant) => variant['option' + index] === selectEls[index - 1].querySelector(':checked').value,
      )
      .map((variant) => variant['option' + (index + 1)]);
    optionEls.forEach((optionEl) => {
      optionEl.classList.remove('unavailable', 'non-existent');
      optionEl.removeAttribute('disabled');
      optionEl.removeAttribute('hidden');
      existingOptionValues.includes(optionEl.getAttribute('value'))
        ? availableOptionValues.includes(optionEl.getAttribute('value'))
          ? (optionEl.innerText = optionEl.getAttribute('value'))
          : ((optionEl.innerText = window.variantStrings.unavailable_with_option.replace(
              '[value]',
              optionEl.getAttribute('value'),
            )),
            optionEl.classList.add('unavailable'),
            disableUnavailable && (optionEl.setAttribute('disabled', ''), optionEl.setAttribute('hidden', '')))
        : ((optionEl.innerText = window.variantStrings.unavailable_with_option.replace(
            '[value]',
            optionEl.getAttribute('value'),
          )),
          optionEl.classList.add('non-existent'),
          optionEl.setAttribute('disabled', ''),
          optionEl.setAttribute('hidden', ''));
    });
  });
}
function findAvailableVariant(containerEl, selectedValues, isRadio = true, skipNonExistent = false, skipUnavailable = false) {
  for (let optionIndex = selectedValues.length - 1; optionIndex >= 0; optionIndex--) {
    const inputGroupEl = isRadio
      ? containerEl.querySelector('.product-form__input:nth-child(' + (optionIndex + 1) + ')')
      : containerEl.querySelectorAll('.select')[optionIndex];
    const inputType = isRadio
      ? inputGroupEl.querySelector('.product-form__input__type').dataset.type
      : 'dropdown';
    const optionEls =
      inputType === 'dropdown'
        ? inputGroupEl.querySelectorAll('option')
        : inputGroupEl.querySelectorAll('input[type="radio"]');
    let currentIndex = Array.from(optionEls).findIndex((optionEl) => optionEl.value === selectedValues[optionIndex]);
    let found = false;
    while (currentIndex < optionEls.length - 1) {
      currentIndex++;
      const candidateEl = optionEls[currentIndex];
      if (
        (!skipNonExistent || !optionEls[currentIndex].classList.contains('non-existent')) &&
        (!skipUnavailable || !optionEls[currentIndex].classList.contains('unavailable'))
      ) {
        selectedValues[optionIndex] = optionEls[currentIndex].value;
        found = true;
        break;
      }
    }
    if (!found) {
      currentIndex = Array.from(optionEls).findIndex((optionEl) => optionEl.value === selectedValues[optionIndex]);
      while (currentIndex > 0) {
        currentIndex--;
        const candidateEl = optionEls[currentIndex];
        if (
          (!skipNonExistent || !optionEls[currentIndex].classList.contains('non-existent')) &&
          (!skipUnavailable || !optionEls[currentIndex].classList.contains('unavailable'))
        ) {
          selectedValues[optionIndex] = optionEls[currentIndex].value;
          found = true;
          break;
        }
      }
    }
    if (found) {
      inputType === 'dropdown'
        ? (inputGroupEl.querySelector('.select__select').value = selectedValues[optionIndex])
        : (inputGroupEl.querySelector(
            'input[type="radio"][value="' + selectedValues[optionIndex] + '"]',
          ).checked = true);
      containerEl.dispatchEvent(new Event('change'));
      return true;
    }
  }
  return false;
}
function updateGiftGoalInStorage({
  giftHandle: giftHandle,
  giftVariantId: giftVariantId,
  unlockType: type,
  unlockRequirement: unlockRequirement,
  unlockTarget: unlockTarget,
}) {
  const storedGifts = JSON.parse(localStorage.getItem('shrine_gift_goals')) || {};
  if (!giftHandle || !giftVariantId || !unlockRequirement || !type) return;
  const giftGoal = {
    type: type,
    gift_handle: giftHandle,
    gift_variant_id: Number(giftVariantId),
    unlock_product_handle: unlockTarget || null,
  };
  type === 'product_variant'
    ? Array.isArray(unlockRequirement)
      ? (giftGoal.valid_variants = unlockRequirement.map((item) => String(item).toLowerCase().trim()))
      : (giftGoal.valid_variants = [String(unlockRequirement).toLowerCase().trim()])
    : (giftGoal.required_quantity = Number(unlockRequirement));
  storedGifts[giftHandle] = giftGoal;
  localStorage.setItem('shrine_gift_goals', JSON.stringify(storedGifts));
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll('.quantity-gift');
    this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    this.quantitySelector = document.getElementById('Quantity-Form--' + this.dataset.section);
    this.unlockedItems = [];
    this.mainProduct = this.dataset.mainProduct;
    this.cartItems = document.querySelector('cart-drawer-items');
    this.unlockBy = this.dataset.unlockBy === 'variant' ? 'variant' : 'quantity';
    this.initUnlock();
    this.saveLocalStorage = this.dataset.saveLocalStorage === 'true';
    if (this.saveLocalStorage && this.unlockBy !== 'variant') this.storeLocalStorageData();
  }
  connectedCallback() {
    if (this.unlockBy !== 'variant') return;
    this._variantUnsub = subscribe('variant-change', ({ data: data }) => {
      if (!data || data.sectionId !== this.dataset.section) return;
      this.unlockGiftsByVariant(data.variant, false);
    });
  }
  disconnectedCallback() {
    if (this._variantUnsub) {
      this._variantUnsub();
      this._variantUnsub = undefined;
    }
  }
  storeLocalStorageData() {
    this.gifts.forEach((gift) => {
      updateGiftGoalInStorage({
        giftHandle: gift.dataset.handle,
        giftVariantId: gift.dataset.product,
        unlockType: 'product_quantity',
        unlockRequirement: gift.dataset.quantity,
        unlockTarget: this.mainProduct,
      });
    });
  }
  initUnlock() {
    if (this.unlockBy === 'variant') {
      const currentVariant = this._readCurrentVariant();
      this.unlockGiftsByVariant(currentVariant, true);
      return;
    }
    let quantity = 1;
    const mainProductCartItems = this.mainProduct
      ? document.querySelectorAll('.cart-item--product-' + this.mainProduct)
      : null;
    if (mainProductCartItems && mainProductCartItems.length) {
      quantity = 0;
      for (let i = 0; i < mainProductCartItems.length; i++) {
        quantity += parseInt(mainProductCartItems[i].dataset.quantity);
      }
    } else {
      if (this.quantityBreaks) quantity = parseInt(this.quantityBreaks.selectedQuantity);
      else {
        if (this.quantitySelector) {
          const quantityInputEl = this.quantitySelector.querySelector('input[name="quantity"]');
          quantity = parseInt(quantityInputEl.value);
        }
      }
    }
    this.unlockGifts(quantity, true);
  }
  unlockGifts(quantity, shouldSync = false) {
    if (this.unlockBy === 'variant') return;
    this.unlockedItems = [];
    this.gifts.forEach((gift) => {
      if (parseInt(gift.dataset.quantity) <= quantity) {
        gift.classList.add('quantity-gift--unlocked');
        gift.dataset.unlocked = 'true';
        const cartItemProductEl = document.querySelector('.cart-item--product-' + gift.dataset.handle);
        if (gift.dataset.product && !cartItemProductEl) this.unlockedItems.unshift(gift.dataset.product);
      } else {
        gift.classList.remove('quantity-gift--unlocked');
        gift.dataset.unlocked = 'false';
      }
    });
    if (this.mainProduct && shouldSync) this.addRemoveProducts();
  }
  _readCurrentVariant() {
    const selectsDataSectionEl = document.querySelector(
      'variant-selects[data-section="' + this.dataset.section + '"]',
    );
    if (!selectsDataSectionEl) return null;
    if (selectsDataSectionEl.currentVariant) return selectsDataSectionEl.currentVariant;
    const selectedOptions = [];
    selectsDataSectionEl.querySelectorAll('.product-form__input').forEach((inputGroupEl) => {
      const formInputTypeEl = inputGroupEl.querySelector('.product-form__input__type');
      const type = formInputTypeEl ? formInputTypeEl.dataset.type : null;
      let item;
      if (type === 'dropdown' || type === 'dropdwon') {
        const selectEl = inputGroupEl.querySelector('.select__select');
        item = selectEl ? selectEl.value : undefined;
      } else {
        const radioEl = inputGroupEl.querySelector('input[type="radio"]:checked');
        item = radioEl ? radioEl.value : undefined;
      }
      if (item !== undefined) selectedOptions.push(item);
    });
    try {
      const jsonEl = selectsDataSectionEl.querySelector('[type="application/json"]');
      if (!jsonEl) return null;
      const variantsData = JSON.parse(jsonEl.textContent);
      return (
        variantsData.find(
          (item) =>
            Array.isArray(item.options) &&
            item.options.length === selectedOptions.length &&
            item.options.every((option, option2) => option === selectedOptions[option2]),
        ) || null
      );
    } catch (error) {
      return null;
    }
  }
  _getOptionOrders() {
    const selectsDataSectionEl = document.querySelector(
      'variant-selects[data-section="' + this.dataset.section + '"]',
    );
    if (!selectsDataSectionEl) return null;
    try {
      const jsonEl = selectsDataSectionEl.querySelector('[type="application/json"]');
      if (!jsonEl) return null;
      const variantsData = JSON.parse(jsonEl.textContent);
      const optionOrders = {
        option1: [],
        option2: [],
        option3: [],
      };
      variantsData.forEach((item) => {
        ['option1', 'option2', 'option3'].forEach((optionKey) => {
          const optionValue = item[optionKey];
          if (item[optionKey] !== null && item[optionKey] !== undefined) {
            const normalizedValue = String(item[optionKey]).toLowerCase().trim();
            if (!optionOrders[optionKey].includes(normalizedValue)) {
              optionOrders[optionKey].push(normalizedValue);
            }
          }
        });
      });
      return optionOrders;
    } catch (error) {
      return null;
    }
  }
  unlockGiftsByVariant(variant, shouldSync = false) {
    this.unlockedItems = [];
    if (!variant) {
      this.gifts.forEach((gift) => {
        gift.classList.remove('quantity-gift--unlocked');
        gift.dataset.unlocked = 'false';
        if (this.saveLocalStorage) {
          removeLocalStorageGift({
            gift_handle: gift.dataset.handle,
          });
        }
      });
      if (this.mainProduct && shouldSync) this.addRemoveProducts();
      return;
    }
    const optionOrders = this._getOptionOrders();
    const normalizedVariant = {
      option1: variant.option1 ? String(variant.option1).toLowerCase().trim() : null,
      option2: variant.option2 ? String(variant.option2).toLowerCase().trim() : null,
      option3: variant.option3 ? String(variant.option3).toLowerCase().trim() : null,
    };
    this.gifts.forEach((gift) => {
      const giftVariant = (gift.dataset.variant || '').toLowerCase().trim();
      if (!giftVariant.length) {
        gift.classList.remove('quantity-gift--unlocked');
        gift.dataset.unlocked = 'false';
        if (this.saveLocalStorage) {
          removeLocalStorageGift({
            gift_handle: gift.dataset.handle,
          });
        }
        return;
      }
      let isUnlocked = false;
      let matchedOrder = [];
      if (optionOrders)
        for (const optionKey of ['option1', 'option2', 'option3']) {
          const orderList = optionOrders[optionKey];
          const giftIndex = optionOrders[optionKey].indexOf(giftVariant);
          if (giftIndex === -1) continue;
          const normalizedValue = normalizedVariant[optionKey];
          const selectedIndex = normalizedVariant[optionKey] ? optionOrders[optionKey].indexOf(normalizedVariant[optionKey]) : -1;
          if (selectedIndex >= giftIndex) {
            isUnlocked = true;
            matchedOrder = optionOrders[optionKey].slice(giftIndex);
          }
          break;
        }
      if (!optionOrders) {
        const variantValues = [
          variant.title,
          variant.option1,
          variant.option2,
          variant.option3,
          ...(Array.isArray(variant.options) ? variant.options : []),
        ]
          .filter((val) => val !== undefined && val !== null)
          .map((str) => String(str).toLowerCase().trim());
        isUnlocked = variantValues.includes(giftVariant);
        matchedOrder = [giftVariant];
      }
      if (isUnlocked) {
        gift.classList.add('quantity-gift--unlocked');
        gift.dataset.unlocked = 'true';
        const cartItemProductEl = document.querySelector('.cart-item--product-' + gift.dataset.handle);
        if (gift.dataset.product && !cartItemProductEl) this.unlockedItems.unshift(gift.dataset.product);
        if (this.saveLocalStorage) {
          updateGiftGoalInStorage({
            giftHandle: gift.dataset.handle,
            giftVariantId: gift.dataset.product,
            unlockType: 'product_variant',
            unlockRequirement: matchedOrder,
            unlockTarget: this.mainProduct,
          });
        }
      } else {
        gift.classList.remove('quantity-gift--unlocked');
        gift.dataset.unlocked = 'false';
        if (this.saveLocalStorage) {
          removeLocalStorageGift({
            gift_handle: gift.dataset.handle,
          });
        }
      }
    });
    if (this.mainProduct && shouldSync) this.addRemoveProducts();
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    const items = document.querySelectorAll('.cart-item--product-' + this.mainProduct);
    this.gifts.forEach((gift) => {
      items.length
        ? gift.dataset.unlocked === 'true' && gift.dataset.product
          ? this.addToCart(gift)
          : this.removeFromCart(gift)
        : this.removeFromCart(gift);
    });
  }
  addToCart(element) {
    const cartItemProductEl = document.querySelector(
      '.cart-item--product-' + element.dataset.handle,
    );
    if (cartItemProductEl) return;
    const productFormEl = element.querySelector('product-form');
    if (productFormEl && productFormEl.handleSubmit) productFormEl.handleSubmit();
  }
  removeFromCart(element) {
    const element2 = document.querySelector('.cart-item--product-' + element.dataset.handle);
    if (!element2 || !this.cartItems) return;
    this.cartItems.updateQuantity(element2.dataset.index, 0);
  }
}
customElements.define('quantity-gifts', QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
  constructor() {
    super();
    this.offerIndex = this.dataset.offer;
    this.upsells = this.querySelectorAll('.quantity-break__upsell');
    this.boundToggleHandler = this.handleToggle.bind(this);
    this.upsells.forEach((upsell) => {
      if (upsell.dataset.toggle === 'true') {
        upsell.addEventListener('click', this.boundToggleHandler);
      }
    });
    this.initUnlock();
    if (this.saveLocalStorage) this.storeLocalStorageData();
  }
  storeLocalStorageData() {
    if (!this.upsells) return;
    this.upsells.forEach((upsell) => {
      if (upsell.dataset.type !== 'gift') return;
      updateGiftGoalInStorage({
        giftHandle: upsell.dataset.handle,
        giftVariantId: upsell.dataset.product,
        unlockType: 'product_quantity',
        unlockRequirement: upsell.dataset.minQuantity,
        unlockTarget: this.dataset.mainProduct,
      });
    });
  }
  disconnectedCallback() {
    this.upsells.forEach((upsell) => {
      if (upsell.dataset.toggle === 'true') {
        upsell.removeEventListener('click', this.boundToggleHandler);
      }
    });
  }
  unlockGifts(quantity, shouldSync = false) {
    this.unlockedItems = [];
    if (!this.upsells) return;
    this.upsells.forEach((upsell) => {
      const minQuantity = parseInt(upsell.dataset.minQuantity || 0);
      const meetsQuantity = quantity >= minQuantity;
      const isSelected = upsell.dataset.selected === 'true';
      const isUnlocked = meetsQuantity && isSelected;
      upsell.dataset.unlocked = isUnlocked.toString();
      upsell.classList.toggle('quantity-gift--unlocked', isUnlocked);
      const cartItemProductEl = document.querySelector(
        '.cart-item--product-' + upsell.dataset.handle,
      );
      if (isUnlocked && upsell.dataset.product && !cartItemProductEl) {
        const hasToggle = upsell.dataset.toggle === 'true';
        const isSelectedCheck = upsell.dataset.selected === 'true';
        if (!hasToggle || (hasToggle && isSelectedCheck)) {
          this.unlockedItems.unshift(upsell.dataset.product);
        }
      }
    });
    if (this.mainProduct && shouldSync) {
      if (this.dataset.lastOffer === this.dataset.offer) this.addRemoveProducts();
    }
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    const mainProductCartItems = document.querySelectorAll('.cart-item--product-' + this.mainProduct);
    const toAdd = [];
    const toRemove = [];
    this.upsells.forEach((upsell) => {
      const cartItemProductEl = document.querySelector(
        '.cart-item--product-' + upsell.dataset.handle,
      );
      const isUnlocked = upsell.dataset.unlocked === 'true';
      if (mainProductCartItems.length) {
        if (isUnlocked && !cartItemProductEl) toAdd.push(upsell);
        else if (!isUnlocked && cartItemProductEl) {
          toRemove.push(upsell);
        }
      } else if (cartItemProductEl) {
        toRemove.push(upsell);
      }
    });
    if (toRemove.length) this.removeFromCart(toRemove[0]);
    else if (toAdd.length) {
      this.addToCart(toAdd[0]);
    }
  }
  handleToggle(event) {
    const upsellEl = event.currentTarget;
    const wasSelected = event.currentTarget.dataset.selected === 'true';
    event.currentTarget.dataset.selected = (!wasSelected).toString();
    this.syncUpsellAcrossOffers(event.currentTarget.dataset.handle, !wasSelected);
    this.syncCart(event.currentTarget.dataset.handle, !wasSelected, event.currentTarget);
  }
  syncUpsellAcrossOffers(handle, toString) {
    const quantityBreakUpsellsEls = document.querySelectorAll('quantity-break-upsells');
    quantityBreakUpsellsEls.forEach((quantityBreakUpsellsEl) => {
      quantityBreakUpsellsEl
        .querySelectorAll('.quantity-break__upsell[data-handle="' + handle + '"]')
        .forEach((element) => {
          element.dataset.selected = toString.toString();
        });
    });
  }
  syncCart(handle, shouldAdd, upsellEl) {
    const cartItemProductEl = document.querySelector('.cart-item--product-' + handle);
    if (!this.cartItems) return;
    if (shouldAdd && !cartItemProductEl) this.addToCart(upsellEl);
    else if (!shouldAdd && cartItemProductEl) {
      this.removeFromCart(upsellEl);
    }
  }
}
customElements.define('quantity-break-upsells', QuantityBreakUpsells);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('.upsell__image__img');
    this.toggleBtn = this.querySelector('.upsell-toggle-btn');
    this.variantSelects = this.querySelector('.upsell__variant-picker');
    this.variantSelectElements = this.querySelectorAll('.select__select');
    this.jsonData = this.querySelector('[type="application/json"]');
    this.productForm = this.querySelector('product-form');
    if (this.productForm) this.idInput = this.productForm.querySelector('[name="id"]');
    this.skipNonExistent = this.dataset.skipNonExistent === 'true';
    this.skipUnavailable = this.dataset.skipUnavailable === 'true';
    this.updatePrices = this.dataset.updatePrices === 'true';
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector('.upsell__price .regular-price');
      this.comparePriceSpan = this.querySelector('.upsell__price .compare-price');
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === 'true';
      if (this.isMainOfferItem)
        this.mainOfferContainer = document.querySelector(
          '#MainBundleOffer-' + this.dataset.section,
        );
    }
    if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.handleToggle.bind(this));
    if (this.variantSelects)
      this.variantSelects.addEventListener('change', this.handleSelectChange.bind(this));
  }
  handleToggle(event) {
    if (
      event.target.nodeName.toLowerCase() === 'select' ||
      event.target.nodeName.toLowerCase() === 'option'
    )
      return;
    this.dataset.selected === 'true'
      ? (this.dataset.selected = 'false')
      : (this.dataset.selected = 'true');
  }
  handleSelectChange(event) {
    const selectEl = event.currentTarget;
    const selectedValues = Array.from(event.currentTarget.querySelectorAll('select'), (opt) => opt.value);
    const foundVariant = this.getVariantData().find((options) => {
      return !options.options
        .map((option, option2) => {
          return selectedValues[option2] === option;
        })
        .includes(false);
    });
    const candidateVariants = this.getVariantData().filter(
      (option1) => event.currentTarget.querySelector(':checked').value === option1.option1,
    );
    const selectEls = [...event.currentTarget.querySelectorAll('select')];
    updateVariantStatuses(candidateVariants, selectEls, this.skipUnavailable);
    if (!foundVariant) {
      if (this.skipNonExistent)
        findAvailableVariant(event.currentTarget, selectedValues, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !foundVariant.available) {
      if (findAvailableVariant(event.currentTarget, selectedValues, false, true, true)) return;
    }
    if (this.updatePrices) {
      this.price = foundVariant.price * this.percentageLeft - this.fixedDiscount;
      this.comparePrice = foundVariant.price;
      if (foundVariant.compare_at_price && foundVariant.compare_at_price > foundVariant.price) {
        this.comparePrice = foundVariant.compare_at_price;
      }
      displayPrices(
        this.price,
        this.comparePrice,
        this.priceSpan,
        this.comparePriceSpan,
        this.moneyFormat,
      );
    }
    if (this.image && foundVariant.featured_image) this.image.src = foundVariant.featured_image.src;
    this.updateId(foundVariant.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices)
      this.mainOfferContainer.updateTotalPrices();
  }
  updateId(id) {
    this.dataset.id = id;
    if (this.idInput) this.idInput.value = id;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
}
customElements.define('product-info-upsell', ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartItems = this.cartDrawer ? this.cartDrawer.querySelector('cart-drawer-items') : null;
    this.classicAddButton = this.querySelector('.upsell__add-btn');
  }
  handleToggle(event) {
    if (
      event.target.nodeName.toLowerCase() === 'select' ||
      event.target.nodeName.toLowerCase() === 'option'
    )
      return;
    this.dataset.selected === 'true'
      ? ((this.dataset.selected = 'false'), this.removeFromCart())
      : ((this.dataset.selected = 'true'), this.addToCart());
  }
  addRemoveFromCart() {
    this.dataset.selected === 'true' && !this.cartDrawer.classList.contains('is-empty')
      ? this.addToCart()
      : this.removeFromCart();
  }
  addToCart() {
    const cartItemProductEl = this.cartDrawer.querySelector(
      '.cart-item--product-' + this.dataset.handle,
    );
    if (cartItemProductEl) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute('disabled', '');
    this.variantSelectElements.forEach((variantSelectElement) => {
      variantSelectElement.setAttribute('disabled', '');
    });
    this.productForm.handleSubmit();
  }
  removeFromCart() {
    const element = this.cartDrawer.querySelector('.cart-item--product-' + this.dataset.handle);
    if (!element || !this.cartItems) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute('disabled', '');
    this.variantSelectElements.forEach((variantSelectElement) => {
      variantSelectElement.setAttribute('disabled', '');
    });
    this.cartItems.updateQuantity(element.dataset.index, 0);
  }
  updateId(id) {
    this.dataset.id = id;
    this.idInput.value = id;
    if (this.classicAddButton) return;
    if (this.dataset.selected === 'true') {
      if (this.selectTimeout) {
        clearTimeout(this.selectTimeout);
      }
      this.removeFromCart();
      const handler = (event) => {
        if (event.detail.handle === 'handle') {
          this.addToCart();
          document.removeEventListener('cartQuantityUpdated', handler);
        }
      };
      document.addEventListener('cartQuantityUpdated', handler);
    }
  }
  getUpdateRequired() {
    const cartItemProductEl = this.cartDrawer.querySelector(
      '.cart-item--product-' + this.dataset.handle,
    );
    let needsUpdate = false;
    if (cartItemProductEl && this.dataset.selected === 'false') needsUpdate = true;
    else if (!cartItemProductEl && this.dataset.selected === 'true') {
      needsUpdate = true;
    }
    return needsUpdate;
  }
}
customElements.define('cart-drawer-upsell', CartDrawerUpsell);
function displayPrices(price, comparePrice, priceEl, comparePriceEl, moneyFormat) {
  if (!moneyFormat) return;
  if (price && priceEl) {
    var innerHTML = formatMoney(price, moneyFormat);
    priceEl.innerHTML = innerHTML;
  }
  if (comparePrice && comparePriceEl) {
    var innerHTML2 = formatMoney(comparePrice, moneyFormat);
    comparePriceEl.innerHTML = innerHTML2;
    comparePrice > price ? comparePriceEl.classList.remove('hidden') : comparePriceEl.classList.add('hidden');
  }
}
function initTrapFocus() {
  isIe = false;
  if (document.querySelector('footer') && document.querySelector('footer').dataset.type === null)
    return false;
  return true;
}
function formatMoney(amount, format, noDecimalsIfZero = false) {
  if (typeof amount == 'string') {
    amount = amount.replace('.', '');
  }
  var result = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function defaultVal(value, fallback) {
    return typeof value == 'undefined' ? fallback : value;
  }
  function formatNumber(value, decimals, thousands, decimalSep) {
    decimals = defaultVal(decimals, 2);
    thousands = defaultVal(thousands, ',');
    decimalSep = defaultVal(decimalSep, '.');
    if (isNaN(value) || value == null) return 0;
    value = (value / 100).toFixed(decimals);
    var parts = value.split('.');
    var integerPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var decimalPart = parts[1] ? decimalSep + parts[1] : '';
    if (noDecimalsIfZero && decimalPart === decimalSep + '00') {
      decimalPart = '';
    }
    return integerPart + decimalPart;
  }
  switch (format.match(/\{\{\s*(\w+)\s*\}\}/)[1]) {
    case 'amount':
      result = formatNumber(amount, 2);
      break;
    case 'amount_no_decimals':
      result = formatNumber(amount, 0);
      break;
    case 'amount_with_comma_separator':
      result = formatNumber(amount, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      result = formatNumber(amount, 0, '.', ',');
      break;
    case 'amount_with_space_separator':
      result = formatNumber(amount, 2, ' ', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      result = formatNumber(amount, 0, ' ', ',');
      break;
    case 'amount_with_apostrophe_separator':
      result = formatNumber(amount, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_apostrophe_separator':
      result = formatNumber(amount, 0, "'", '.');
      break;
  }
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, result);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
    this.saveLocalStorage = this.dataset.saveLocalStorage === 'true';
    if (this.saveLocalStorage) this.storeLocalStorageData();
  }
  storeLocalStorageData() {
    if (
      !this.dataset.handle ||
      !this.dataset.id ||
      !this.dataset.mainProduct ||
      !this.dataset.requirement ||
      !this.dataset.type
    )
      return;
    updateGiftGoalInStorage({
      giftHandle: this.dataset.handle,
      giftVariantId: this.dataset.id,
      unlockType: this.dataset.type,
      unlockRequirement: Number(this.dataset.requirement),
      unlockTarget: this.dataset.mainProduct,
    });
  }
}
customElements.define('cart-drawer-gift', CartDrawerGift);
function initToggleUpsells() {
  const cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    cartDrawerEl
      .querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
      .forEach((upsellEl) => {
        if (upsellEl.addRemoveFromCart) upsellEl.addRemoveFromCart();
      });
  }
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll('.main-offer-item');
    this.updatePrices = this.dataset.updatePrices === 'true';
    if (this.updatePrices) {
      this.priceSpan = this.querySelector('.bundle-deals__total-price-js');
      this.comparePriceSpan = this.querySelector('.bundle-deals__total-compare-price-js');
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
    }
  }
  updateTotalPrices() {
    if (!this.updatePrices) return;
    var price = 0;
    var comparePrice = 0;
    for (let i = 0; i < this.offerItems.length; i++) {
      price += parseInt(this.offerItems[i].price);
      comparePrice += parseInt(this.offerItems[i].comparePrice);
    }
    price = price * this.percentageLeft - this.fixedDiscount;
    displayPrices(price, comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define('main-bundle-offer', MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector('[type="text"], [type="number"], textarea');
    this.inputRadios = this.querySelectorAll('[type="radio"]');
    this.select = this.querySelector('.select__select');
    this.productForm = document.getElementById('product-form-' + this.dataset.section);
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === 'true';
    this.isText = true;
    this.notMain = this.dataset.notMain === 'true';
    if (this.dataset.type === 'select' || this.dataset.type === 'pills') this.isText = false;
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true;
      this.atcButtons = this.notMain
        ? document.querySelectorAll('.featured-product-atc-' + this.dataset.section)
        : document.querySelectorAll('.main-product-atc');
      this.mainAtcButton = this.productForm.querySelector(
        '#ProductSubmitButton-' + this.dataset.section,
      );
      this.mainAtcBtnLabel = this.mainAtcButton.querySelector('.main-atc__label');
      this.mainAtcBtnError = this.mainAtcButton.querySelector('.main-atc__error');
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields =
        parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      if (this.mainAtcBtnError) this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === 'true';
      this.stickyAtcButton = document.querySelector('#sticky-atc-' + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector('.sticky-atc__label');
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector('.sticky-atc__error');
        if (this.stickyAtcBtnError) this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) this.input.addEventListener('input', this.handleChange.bind(this));
    this.inputRadios.forEach((inputRadio) => {
      inputRadio.addEventListener('input', this.handleChange.bind(this));
    });
    if (this.select) this.select.addEventListener('change', this.handleChange.bind(this));
  }
  handleChange(event) {
    const prevValue = event.target.value.trim();
    if (event.target.checkValidity()) this.prevValue = prevValue;
    else {
      event.target.value = this.prevValue;
      return;
    }
    this.dataset.value = prevValue;
    this.productFormInput.value = prevValue;
    if (this.isRequired && this.isText) this.validateValue(prevValue, event.target);
  }
  validateValue(value, inputEl) {
    const isValid = value.length > 0 ? true : false;
    if (isValid === this.isValid) return;
    this.isValid = isValid;
    if (inputEl) {
      this.isValid
        ? (inputEl.classList.remove('input--error'),
          (this.mainAtcButton.dataset.validFields =
            parseInt(this.mainAtcButton.dataset.validFields) + 1))
        : (inputEl.classList.add('input--error'),
          (this.mainAtcButton.dataset.validFields =
            parseInt(this.mainAtcButton.dataset.validFields) - 1));
    }
    const allFieldsValid = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
    const isUnavailable = this.mainAtcButton.dataset.unavailable === 'true';
    this.atcButtons.forEach((atcButton) => {
      allFieldsValid && !isUnavailable ? atcButton.removeAttribute('disabled') : atcButton.setAttribute('disabled', '');
    });
    if (this.atcErrorMsg.length === 0) return;
    allFieldsValid
      ? ((this.mainAtcBtnLabel.style.display = ''),
        (this.mainAtcBtnError.style.display = 'none'),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel.style.display = ''),
          (this.stickyAtcBtnError.style.display = 'none')))
      : ((this.mainAtcBtnLabel.style.display = 'none'),
        (this.mainAtcBtnError.style.display = ''),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel.style.display = 'none'),
          (this.stickyAtcBtnError.style.display = '')));
  }
  createInputs() {
    this.productFormInput = document.createElement('input');
    this.productFormInput.setAttribute('type', 'hidden');
    this.productFormInput.setAttribute('name', 'properties[' + this.fieldName + ']');
    this.productFormInput.value = this.dataset.defaultValue;
    this.productFormInput.classList.add('shrine-property-input');
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define('custom-product-field', CustomProductField);
function playMedia() {
  if (!serial) serial = document.currentScript.dataset.animationsType || '';
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = 'StickyAtcVariantPicker-';
    this.secondarySelect = document.getElementById(
      '' + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === 'true';
    this.prependMedia = this.dataset.disablePrepend != 'true';
    this.filtering = this.dataset.hasFiltering === 'true';
    this.skipNonExistent = this.dataset.skipNonExistent === 'true';
    this.skipUnavailable = this.dataset.skipUnavailable === 'true';
    if (this.hasQuantityBreaksPicker) {
      this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
      this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages;
    }
    this.addEventListener('change', this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      if (
        this.skipNonExistent &&
        findAvailableVariant(this, this.options, true, true, this.skipUnavailable)
      )
        return;
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) return;
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const options = [];
    this.querySelectorAll('.product-form__input').forEach((inputGroupEl) => {
      let option;
      const inputType = inputGroupEl.querySelector('.product-form__input__type').dataset.type;
      inputGroupEl.querySelector('.product-form__input__type').dataset.type == 'dropdown' ||
      inputGroupEl.querySelector('.product-form__input__type').dataset.type == 'dropdwon'
        ? (option = inputGroupEl.querySelector('.select__select').value)
        : (option = inputGroupEl.querySelector('input[type="radio"]:checked').value);
      options.push(option);
    });
    this.options = options;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((options) => {
      return !options.options
        .map((option, option2) => {
          return this.options[option2] === option;
        })
        .includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const items = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
    items.forEach((item) =>
      item.setActiveMedia(
        this.dataset.section + '-' + this.currentVariant.featured_media.id,
        this.prependMedia,
        this.filtering,
        this.currentVariant,
      ),
    );
    const productmodalEl = document.querySelector(
      '#ProductModal-' + this.dataset.section + ' .product-media-modal__content',
    );
    if (!productmodalEl) return;
    const dataMediaIdEl = productmodalEl.querySelector(
      '[data-media-id="' + this.currentVariant.featured_media.id + '"]',
    );
    productmodalEl.prepend(dataMediaIdEl);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', this.dataset.url + '?variant=' + this.currentVariant.id);
  }
  updateShareUrl() {
    const shareEl = document.getElementById('Share-' + this.dataset.section);
    if (!shareEl || !shareEl.updateUrl) return;
    shareEl.updateUrl(
      '' + window.shopUrl + this.dataset.url + '?variant=' + this.currentVariant.id,
    );
  }
  updateVariantInput() {
    const items = document.querySelectorAll(
      '#product-form-' +
        this.dataset.section +
        ', #product-form-installment-' +
        this.dataset.section,
    );
    items.forEach((item) => {
      const inputNameIdEl = item.querySelector('input[name="id"]');
      inputNameIdEl.value = this.currentVariant.id;
      inputNameIdEl.dispatchEvent(
        new Event('change', {
          bubbles: true,
        }),
      );
    });
  }
  updateVariantStatuses() {
    const matchingVariants = this.variantData.filter(
      (item) => this.querySelector(':checked').value === item.option1,
    );
    let inputGroups;
    this.isSecondary && this.secondarySelect
      ? (inputGroups = [...this.secondarySelect.querySelectorAll('.product-form__input')])
      : (inputGroups = [...this.querySelectorAll('.product-form__input')]);
    inputGroups.forEach((inputGroup, index) => {
      if (index === 0) return;
      const optionEls = [...inputGroup.querySelectorAll('input[type="radio"], .select__select option')];
      const prevValue = inputGroups[index - 1].querySelector(':checked').value;
      const availableValues = matchingVariants
        .filter(
          (variant) =>
            variant.available &&
            variant['option' + index] === inputGroups[index - 1].querySelector(':checked').value,
        )
        .map((variant) => variant['option' + (index + 1)]);
      const existingValues = matchingVariants
        .filter(
          (variant) => variant['option' + index] === inputGroups[index - 1].querySelector(':checked').value,
        )
        .map((variant) => variant['option' + (index + 1)]);
      this.setInputAvailability(optionEls, availableValues, existingValues, this.skipNonExistent, this.skipUnavailable);
    });
  }
  setInputAvailability(optionEls, availableValues, existingValues, skipNonExistent = false, skipUnavailable = false) {
    optionEls.forEach((item) => {
      item.classList.remove('unavailable', 'non-existent', 'disabled');
      item.removeAttribute('disabled');
      item.removeAttribute('hidden');
      const innerText = item.getAttribute('value');
      let element = null;
      if (item.dataset.swatch === 'true') {
        element = item.closest('.color-swatch');
      }
      if (element) element.classList.remove('unavailable', 'non-existent', 'disabled');
      if (existingValues.includes(innerText)) {
        if (availableValues.includes(innerText)) {
          if (item.nodeName === 'OPTION') item.innerText = innerText;
          else {
            item.classList.remove('disabled');
            if (element) element.classList.remove('disabled');
          }
        } else {
          if (item.nodeName === 'OPTION') {
            item.innerText = window.variantStrings.unavailable_with_option.replace(
              '[value]',
              innerText,
            );
            item.classList.add('unavailable');
            if (skipUnavailable) {
              item.setAttribute('disabled', '');
              item.setAttribute('hidden', '');
            }
          } else {
            item.classList.add('disabled', 'unavailable');
            if (element) element.classList.add('disabled', 'unavailable');
          }
        }
      } else {
        if (item.nodeName === 'OPTION') {
          item.innerText = window.variantStrings.unavailable_with_option.replace(
            '[value]',
            innerText,
          );
          item.classList.add('non-existent');
          if (skipNonExistent) {
            item.setAttribute('disabled', '');
            item.setAttribute('hidden', '');
          }
        } else {
          item.classList.add('disabled', 'non-existent');
          if (element) element.classList.add('disabled', 'non-existent');
        }
      }
    });
  }
  updatePickupAvailability() {
    const pickupAvailabilityEl = document.querySelector('pickup-availability');
    if (!pickupAvailabilityEl) return;
    if (this.currentVariant && this.currentVariant.available) {
      if (pickupAvailabilityEl.fetchAvailability)
        pickupAvailabilityEl.fetchAvailability(this.currentVariant.id);
    } else {
      pickupAvailabilityEl.removeAttribute('available');
      pickupAvailabilityEl.innerHTML = '';
    }
  }
  removeErrorMessage() {
    const sectionEl = this.closest('section');
    if (!sectionEl) return;
    const productFormEl = sectionEl.querySelector('product-form');
    if (productFormEl) productFormEl.handleErrorMessage();
  }
  renderProductInfo() {
    const variantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      this.dataset.url +
        '?variant=' +
        this.currentVariant.id +
        '&section_id=' +
        (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
    )
      .then((response) => response.text())
      .then((result) => {
        if (this.currentVariant.id !== this.currentVariant.id) return;
        const doc = new DOMParser().parseFromString(result, 'text/html');
        const priceEl = document.getElementById('price-' + this.dataset.section);
        const priceEl2 = doc.getElementById(
          'price-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        const atcSeparatePriceEl = document.getElementById(
          'sticky-atc-separate-price-' + this.dataset.section,
        );
        const atcSeparatePriceEl2 = doc.getElementById(
          'sticky-atc-separate-price-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        const stickyAtcPriceEl = document.getElementById(
          'sticky-atc-price-' + this.dataset.section,
        );
        const stickyAtcPriceEl2 = doc.getElementById(
          'sticky-atc-price-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        const stickyAtcImageEl = document.getElementById(
          'sticky-atc-image-' + this.dataset.section,
        );
        if (stickyAtcImageEl && this.currentVariant.featured_image)
          stickyAtcImageEl.src = this.currentVariant.featured_image.src;
        const mainAtcPriceEl = document.getElementById('main-atc-price-' + this.dataset.section);
        const mainAtcPriceEl2 = doc.getElementById(
          'main-atc-price-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        const items = document.querySelectorAll(
          '[id^="custom-label-' + this.dataset.section + '"]',
        );
        const items2 = doc.querySelectorAll(
          '[id^="custom-label-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) +
            '"]',
        );
        const element = doc.getElementById(
          'Sku-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        const element2 = document.getElementById('Sku-' + this.dataset.section);
        const inventoryEl = doc.getElementById(
          'Inventory-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        const element3 = document.getElementById('Inventory-' + this.dataset.section);
        if (priceEl && priceEl2) priceEl.innerHTML = priceEl2.innerHTML;
        if (atcSeparatePriceEl && atcSeparatePriceEl2)
          atcSeparatePriceEl.innerHTML = atcSeparatePriceEl2.innerHTML;
        if (stickyAtcPriceEl && stickyAtcPriceEl2)
          stickyAtcPriceEl.innerHTML = stickyAtcPriceEl2.innerHTML;
        if (mainAtcPriceEl2 && mainAtcPriceEl) mainAtcPriceEl.innerHTML = mainAtcPriceEl2.innerHTML;
        if (items && items2)
          for (var i = 0; i < items.length; i++) {
            items[i].innerHTML = items2[i].innerHTML;
          }
        if (inventoryEl && element3) element3.innerHTML = inventoryEl.innerHTML;
        if (element && element2) {
          element2.innerHTML = element.innerHTML;
          element2.classList.toggle(
            'visibility-hidden',
            element.classList.contains('visibility-hidden'),
          );
        }
        if (this.QuantityBreaks) {
          const quantityBreaksEl = doc.getElementById(
            'quantity-breaks-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          );
          const dynamicPriceEls = this.QuantityBreaks.querySelectorAll('.dynamic-price');
          const newDynamicPriceEls = quantityBreaksEl.querySelectorAll('.dynamic-price');
          for (let i = 0; i < dynamicPriceEls.length; i++) {
            dynamicPriceEls[i].innerHTML = newDynamicPriceEls[i].innerHTML;
          }
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach((variantSelect) => {
              variantSelect.dataset.selectedId = this.currentVariant.id;
            });
            const variantSelectEls = this.QuantityBreaks.querySelectorAll(
              '.quantity-break__variant-select',
            );
            const newVariantSelectEls = quantityBreaksEl.querySelectorAll('.quantity-break__variant-select');
            for (let i = 0; i < variantSelectEls.length; i++) {
              variantSelectEls[i].innerHTML = newVariantSelectEls[i].innerHTML;
            }
            this.QuantityBreaks.initVariants();
          }
          if (this.currentVariant.featured_image) {
            this.QuantityBreaks.querySelectorAll(
              '.quantity-break__selector-item__image img',
            ).forEach((src) => {
              src.src = this.currentVariant.featured_image.src;
            });
          }
          if (this.QuantityBreaks.updatePdpPrices) {
            this.QuantityBreaks.dataset.basePrice = quantityBreaksEl.dataset.basePrice;
            this.QuantityBreaks.labels.forEach((label) => {
              label.dataset.baseComparePrice = quantityBreaksEl.querySelector(
                'label[data-input="' + label.dataset.input + '"]',
              ).dataset.baseComparePrice;
            });
            this.QuantityBreaks.initOfferPrices(true);
            this.QuantityBreaks.updateInnerPrices();
          }
        }
        const element4 = document.getElementById('SubscriptionWidget-' + this.dataset.section);
        const element5 = doc.getElementById(
          'SubscriptionWidget-' +
            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
        );
        if (element4) {
          if (!element5) element4.classList.add('hidden');
          else {
            element4.dataset.basePrice = element5.dataset.basePrice || '';
            element4.dataset.baseComparePrice = element5.dataset.baseComparePrice || '';
            const planChanged =
              (element4.dataset.firstSellingPlanId || '') !==
              (element5.dataset.firstSellingPlanId || '');
            if (planChanged && typeof element4.hydrateFromExternalHTML === 'function')
              element4.hydrateFromExternalHTML(element5);
            else {
              const oneTimeTextEls = element4.querySelectorAll('.one-time-price-update');
              const newOneTimeTextEls = element5.querySelectorAll('.one-time-price-update');
              for (let i = 0; i < oneTimeTextEls.length; i++) {
                oneTimeTextEls[i].innerHTML = newOneTimeTextEls[i].innerHTML;
              }
              if (element4.updatePrices) element4.updateAllPrices();
            }
          }
        }
        if (this.hasQuantityBreaksPicker) {
          const newVariantSelectsEl = doc.getElementById(
            'variant-selects-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          );
          const dynamicPriceEls2 = this.querySelectorAll('.dynamic-price');
          const newDynamicPriceEls2 = newVariantSelectsEl.querySelectorAll('.dynamic-price');
          for (let i = 0; i < dynamicPriceEls2.length; i++) {
            dynamicPriceEls2[i].innerHTML = newDynamicPriceEls2[i].innerHTML;
          }
          if (
            this.quantityBreaksPickerStyle === 'vertical' &&
            this.quantityBreaksPickerDisplayedImages === 'variant_images'
          ) {
            const quantityBreakImgEls = this.querySelectorAll('.quantity-break__image img');
            const newQuantityBreakImgEls = newVariantSelectsEl.querySelectorAll('.quantity-break__image img');
            for (let i = 0; i < quantityBreakImgEls.length; i++) {
              quantityBreakImgEls[i].src = newQuantityBreakImgEls[i].src;
            }
          }
          const newQuantityBreakEls = newVariantSelectsEl.querySelectorAll('.quantity-break[data-base-price]');
          const quantityBreakEls = this.querySelectorAll('.quantity-break');
          for (
            let i = 0;
            i < quantityBreakEls.length && i < newQuantityBreakEls.length;
            i++
          ) {
            if (newQuantityBreakEls[i].dataset.basePrice) {
              quantityBreakEls[i].dataset.basePrice = newQuantityBreakEls[i].dataset.basePrice;
              quantityBreakEls[i].dataset.baseComparePrice =
                newQuantityBreakEls[i].dataset.baseComparePrice;
            }
          }
          const subscriptionWidgetEl = document.getElementById('SubscriptionWidget-' + this.dataset.section);
          if (subscriptionWidgetEl && subscriptionWidgetEl.isSubSelected && this.updateQuantityBreaksPickerPrices) {
            this.updateQuantityBreaksPickerPrices(
              subscriptionWidgetEl.discountType,
              subscriptionWidgetEl.discountValue,
              subscriptionWidgetEl.moneyFormat,
            );
          }
        }
        if (this.secondarySelect) {
          const newSecondarySelectEl = doc.getElementById(
            '' +
              this.secondarySelectSelector +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          );
          if (newSecondarySelectEl) this.secondarySelect.innerHTML = newSecondarySelectEl.innerHTML;
        }
        const element6 = document.getElementById('price-' + this.dataset.section);
        if (element6) element6.classList.remove('visibility-hidden');
        this.dataset.options = this.currentVariant.options.join(',');
        if (element3) element3.classList.toggle('visibility-hidden', inventoryEl.innerText === '');
        const productsubmitbuttonEl = doc.getElementById('ProductSubmitButton-' + sectionId);
        this.toggleAddButton(
          productsubmitbuttonEl ? productsubmitbuttonEl.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );
        publish('variant-change', {
          data: {
            sectionId: sectionId,
            html: doc,
            variant: this.currentVariant,
          },
        });
      });
  }
  toggleAddButton(disabled = true, textContent, updateStickyAtc = true) {
    const productFormEl = document.getElementById('product-form-' + this.dataset.section);
    if (!productFormEl) return;
    const nameAddEl = productFormEl.querySelector('[name="add"]');
    if (!nameAddEl) return;
    const mainProductAtcEls = document.querySelectorAll('.main-product-atc');
    var atcLabelTextEl = productFormEl.querySelector('.main-atc__label__text');
    if (!atcLabelTextEl) atcLabelTextEl = productFormEl.querySelector('.main-atc__label');
    const mainAtcPriceEl = productFormEl.querySelector('.main-atc-price');
    const atcAddButtonEl = document.querySelector('.sticky-atc__add_button');
    let stickyAtcLabelTextEl = null;
    let stickyAtcPriceEl = null;
    if (atcAddButtonEl) {
      stickyAtcLabelTextEl = atcAddButtonEl.querySelector('.sticky-atc__label__text');
      stickyAtcPriceEl = atcAddButtonEl.querySelector('.sticky-atc__button-price');
    }
    if (disabled) {
      nameAddEl.setAttribute('disabled', 'disabled');
      nameAddEl.setAttribute('data-unavailable', 'true');
      if (textContent && atcLabelTextEl) atcLabelTextEl.textContent = textContent;
      if (textContent && stickyAtcLabelTextEl && atcAddButtonEl.dataset.label) stickyAtcLabelTextEl.textContent = textContent;
      mainProductAtcEls.forEach((mainProductAtcEl) => {
        mainProductAtcEl.setAttribute('disabled', 'disabled');
      });
      if (mainAtcPriceEl) mainAtcPriceEl.classList.add('hidden');
      if (stickyAtcPriceEl) stickyAtcPriceEl.classList.add('hidden');
    } else {
      nameAddEl.setAttribute('data-unavailable', 'false');
      const addToCartLabel = nameAddEl.dataset.customLabel ?? window.variantStrings.addToCart;
      if (atcLabelTextEl) atcLabelTextEl.textContent = addToCartLabel;
      if (mainAtcPriceEl) mainAtcPriceEl.classList.remove('hidden');
      if (stickyAtcLabelTextEl && atcAddButtonEl.dataset.label) stickyAtcLabelTextEl.textContent = atcAddButtonEl.dataset.label;
      if (stickyAtcPriceEl) stickyAtcPriceEl.classList.remove('hidden');
      if (nameAddEl.dataset.requiredFields === nameAddEl.dataset.validFields) {
        nameAddEl.removeAttribute('disabled');
        mainProductAtcEls.forEach((mainProductAtcEl) => {
          mainProductAtcEl.removeAttribute('disabled');
        });
      }
    }
    if (!updateStickyAtc) return;
  }
  setUnavailable() {
    const productFormEl = document.getElementById('product-form-' + this.dataset.section);
    if (!productFormEl) return;
    const nameAddEl = productFormEl.querySelector('[name="add"]');
    var atcLabelTextEl = productFormEl.querySelector('.main-atc__label__text');
    if (!atcLabelTextEl) atcLabelTextEl = productFormEl.querySelector('.main-atc__label');
    const element = document.getElementById('price-' + this.dataset.section);
    const element2 = document.getElementById('Inventory-' + this.dataset.section);
    const element3 = document.getElementById('Sku-' + this.dataset.section);
    if (!nameAddEl) return;
    if (atcLabelTextEl) atcLabelTextEl.textContent = window.variantStrings.unavailable;
    if (element) element.classList.add('visibility-hidden');
    if (element2) element2.classList.add('visibility-hidden');
    if (element3) element3.classList.add('visibility-hidden');
  }
  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateQuantityBreaksPickerPrices(discountType, discountValue, moneyFormat) {
    if (!this.hasQuantityBreaksPicker) return;
    const quantityBreakEls = this.querySelectorAll('.quantity-break');
    if (!quantityBreakEls.length) return;
    quantityBreakEls.forEach((quantityBreakEl) => {
      if (!quantityBreakEl.dataset.basePrice) return;
      const basePrice = parseInt(quantityBreakEl.dataset.basePrice);
      const baseComparePrice = parseInt(quantityBreakEl.dataset.baseComparePrice) || basePrice;
      let discountedPrice = basePrice;
      if (discountType && discountValue) {
        if (discountType === 'fixed_amount') discountedPrice = Math.max(0, basePrice - discountValue);
        else {
          if (discountType === 'percentage') discountedPrice = Math.round((basePrice * (100 - discountValue)) / 100);
          else if (discountType === 'price') {
            discountedPrice = discountValue;
          }
        }
      }
      const amountSaved = baseComparePrice - discountedPrice;
      const amountSavedRounded = Math.round(amountSaved / 100) * 100;
      const percentageSaved = baseComparePrice > 0 ? Math.round((amountSaved / baseComparePrice) * 100) : 0;
      const priceText = formatMoney(discountedPrice, moneyFormat, true);
      const comparePriceText = formatMoney(baseComparePrice, moneyFormat, true);
      const amountSavedText = formatMoney(amountSaved, moneyFormat, true);
      const amountSavedRoundedText = formatMoney(amountSavedRounded, moneyFormat, true);
      const updateDataTextEls = quantityBreakEl.querySelectorAll(
        '.variant-price-update[data-text]',
      );
      updateDataTextEls.forEach((updateDataTextEl) => {
        let innerHTML = updateDataTextEl.dataset.text;
        innerHTML = innerHTML.replace('[price]', priceText);
        innerHTML = innerHTML.replace('[compare_price]', comparePriceText);
        innerHTML = innerHTML.replace('[amount_saved]', amountSavedText);
        innerHTML = innerHTML.replace('[amount_saved_rounded]', amountSavedRoundedText);
        innerHTML = innerHTML.replace('[percentage_saved]', percentageSaved + '%');
        updateDataTextEl.innerHTML = innerHTML;
      });
      const breakComparePriceEl = quantityBreakEl.querySelector('.quantity-break__compare-price');
      if (breakComparePriceEl) {
        baseComparePrice > discountedPrice
          ? breakComparePriceEl.classList.remove('hidden')
          : breakComparePriceEl.classList.add('hidden');
      }
    });
  }
}
customElements.define('variant-selects', VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = 'variant-selects-';
    this.secondarySelect = document.getElementById(
      '' + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector('select').value.split(',');
  }
}
customElements.define('secondary-variant-select', SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = 'variant-selects-';
    this.secondarySelect = document.getElementById(
      '' + this.secondarySelectSelector + this.dataset.section,
    );
    this.isSecondary = true;
  }
}
customElements.define('secondary-variant-select-separate', SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.quickAddSubmit = document.getElementById(this.dataset.section + '-submit');
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantStatuses();
    !this.currentVariant
      ? (this.toggleAddButton(true, '', true), this.setUnavailable())
      : (this.updateMedia(),
        this.updateVariantInput(),
        this.updateQuickAddUrl(),
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut));
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const imageEl = document.getElementById(this.dataset.section + '-image');
    if (!imageEl) return;
    const previewImage = this.currentVariant.featured_media.preview_image;
    const baseSrc = this.currentVariant.featured_media.preview_image.src.split('?')[0];
    const widths = [165, 360, 533, 720, 940, 1066];
    const srcsetParts = widths
      .filter((width) => this.currentVariant.featured_media.preview_image.width >= width)
      .map(
        (width) =>
          this.currentVariant.featured_media.preview_image.src.split('?')[0] +
          '?width=' +
          width +
          ' ' +
          width +
          'w',
      )
      .join(', ');
    imageEl.srcset =
      srcsetParts +
      ', ' +
      this.currentVariant.featured_media.preview_image.src.split('?')[0] +
      ' ' +
      this.currentVariant.featured_media.preview_image.width +
      'w';
    imageEl.src = this.currentVariant.featured_media.preview_image.src.split('?')[0] + '?width=533';
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) return;
    this.quickAddSubmit.dataset.productUrl =
      this.dataset.url + '?variant=' + this.currentVariant.id;
  }
}
customElements.define('card-variant-selects', CardVariantSelects);
